/*
 * 雨课堂 国际化静态文字
 * @author: chenzhou
 * @update: 2017.12.01
 * @desc 国际化 命名空间格式 page-module-lable
 *
 */

let pages = {
  // 常用语
  common: {
    "lang":"english",
    "ykt": "Rain Classroom",
    "cancel": "Cancel",
    "confirm": "OK",
    "finishok": "Confirm",
    "close":"Close",
    "publish": "Publish",
    "back": "Back",
    "del": "Delete",
    "remove": "Remove",
    "point": "Point",
    "score": "Score",
    "name": "Name",
    "anonymous": "Anonymous",
    "unread": "Unread",
    "anonymouspoll": "Anonymous Poll",
    "poll": "Poll",
    "option": "Option",
    "anonymous": "Anonymous Poll",
    "multiplem": "Multiple Question (Multiple answers)",
    "multiples": "Multiple Question (Single answer)",
    "subjective": "Subjective Question",
    "blank": "Blank",
    "chooselimit": "Select {count} options",
    "locate": "Question {index}",
    "quiz" : "quiz",
    "slide" : "slide",
    "searchone": "Search",
    "pull": "Pull down",
    "release": "Release",
    "loadingText": "Loading…",
    "Lotuspond": "Lotus Pond",
    "cancelselall": "Cancel",
    "continue": "Continue",
  },

    // 导航菜单
    nav: {
        "course": "Courses",
        "discover": "Discover",
        "message": "Messages",
        "me": "Me",
        // "myhomepage": "My Homepage",
        "myhomepage": "Homepage",
        "myslides": "My Slides",
        "mytests": "My Tests",
        "mysave": "Saved"
    },


    // 课程 教学日志 学习日志
    course: {
        "inclasstip": "Class has already started",
        "courseandclass": "Courses",
        "openclass": "Open Class",
        "addacourse": "Create Course",
        "coursejoinclass": "Join Class",
        "inclass": "In class",
        "coursemanage": "Manage",
        "courseinclassstudent": "{count}",
        "coursemanaged": "Managed",
        "coursejoined": "Joined",
        "coursequitclass": "Quit Class",
        "coursequitcfm": "Are you sure to quit?",
        "coursetips": "Tips",
        "courseenterclasscode": "Enter invite code and join class.",
        "classjoinfailed": "Join Class Failed",
        "coursecreate": "Course",
        "coursecreateexample": "e.g. Fluid Mechanics",
        "classexample": "e.g. Class A",
        "classcreate": "Class",
        "courseaddclass": "Add Class",
        "coursecreatedone": "Done",

        "createOK":"Successful",
        "tip_invitestudent":"You can enter class to invite students.",
        "youcreateclass":"Class you create",
        "enterclass":"Enter Class",
        "returncourselist":"Return to Course List",
        "rename":"Rename",
        "classname":"Class Name",
        "save":"Save",
        "dialog_tip":"Tips",

        "dellastclass": "One class in a course at least",
        "courseaddcourse": "Add Course",
        "courseeditcourse": "Edit Course",
        "coursedelclasswarning": "Are you sure to delete?",
        "entercoursename": "Please enter course name",
        "enterclassname": "Please enter class name",
        "coursedelcoursewarning": "Are you sure to delete?",
        "coursedelcoursecfm": "Once you delete the course, all classes in that course will be deleted.",

        "teachinghistory": "Activities",
        "managestudent": "Students",
        "learninghistory": "Activities",
        "coursemyclassmate": "Classmates",
        "courseinvitestudent": "Invite",
        "coursepermission": "Permission",
        "coursemanageagain": "Manage",
        "coursequit": "Exit",
        "enterclass": "Enter Class",

        "coursepublishslides": "Slides",
        "coursepublishquiz": "Quizzes",
        "courseannounce": "Announcement",
        "courseno学习日志": "No 学习日志",
        "coursepublishintro": 'Click "+" to publish slides, quizzes or announcement~',
        "courseteachercheckall": "Check the published slides, teaching history and quizzes here~",
        "scheduledeliver": "Schedule Deliver",
        "scheduledeliverpublish": "You have {length} Schedule Delivers.",
        "coursefold": "Fold",
        "courseunfold": "Unfold",
        "courseslides": "Slides",
        "coursequiz": "Quizzes",
        "courseedittitle": "Edit Title",
        "coursedel": "Delete",
        "courseinclass": "Lecture",
        "courseannounce2": "Announcement",
        "coursexperiment": "Experiment",
        "coursenostudentpush": "No student in class.",
        "courserightnow": "Right Now",
        "courseinvite": "Invite",
        "coursesearch": "Search",
        "courseteacher": "Instructor",
        "coursecoteacher": "Co-instructor",
        "exitcourse": "Exit",
        "coursestudent": "Student",
        "coursenotbound": "Not bound",
        "coursegueststudent": "Guest Student",

        "coteachernoedit": "The co-teacher is not allowed to edit title.",
        "coteachernodel": "The co-teacher is not allowed to delete teaching activities.",
        "courseaddtitle": "Click to add new title~",
        "coursedelpubish": "Are you sure to delete?",
        "courseactivitydel": "Are you sure to delete the teaching activity?",
        "coursedelcfm": "Are you sure to delete the student?",
        "coursebecomecfm": "Are you confirming your transfer as a regular student?",

        "coursedelstudentfailed": "Delete Failed",
        "courseexitcfm": "Are you sure to exit?",
        "coursefailtoexit": "Exit Failed",

        "coursesun": "Sun",
        "coursemon": "Mon",
        "coursetue": "Tue",
        "coursewed": "Wed",
        "coursethu": "Thu",
        "coursefri": "Fri",
        "coursesat": "Sat",
        // "": "周{number}", 其实英文里不用有这个了。。。
        "appointmentmins": "Send in {minute} mins",
        "appointmenthours": "Send in {hour} hours",
        "appointmentdays": "Send in {days} days",
        "appointmentfailed": "Send Failed",

        // 学生管理
        "coteacherinclass": "Co-instructor",
        "addcoteacher": "Add Co-instructor",
        "setpermission": "Set Permission",
        "deletepermissioncfm": "Are you sure to delete?",
        "deletepermissionfailed": "Delete Failed",
        "selectall": "Select All",
        "selectnone": "Select None",
        "confirmdelete": "Delete",
        "confirmdelete1": "Remove",
        "managetips": "You can only manage guest students.",
        "managetipshasadmin": "This course has opened up the ability for teachers to manage class members, both students and spectators",
        "auditorbecomes": "Auditor's transfer",
        "becomesregular": "Regularize",
        "managestudents": "Manage Students",
        "clear": "Clear",

        "noaddtests": "You haven't added any tests.",
        "coursechooseslide": "Choose one slide only",
        "coursedelstudent": "Are you sure to delete?",
        "deleteOK": "OK",
        "saveOK": "OK",

        // 新增
        "invitestudent": "Invite Student",
        "ArchivedClasses": "Archived Classes",
        "no_guest_student_tip": "No guest student here",
        "pullrefresh": "Pull up to refresh",
        "toprelease": "Pull up to refresh",
        "toploading": "Loading...",
        "nonetwork": "Network unavailable",
        "loadmore": "Load more",
        "sending": 'sending',

        "new_onlessontip": "{length} class(es) on live",
        "new_teach": "Teach",
        "new_listen": "Listen",
        "new_myteach": "Managed",
        "new_mylisten": "Joined",
        "onlessonbar": "{count} class(es) on live",
        "onlessonbar2": "{count} class(es) on live",
        "semicolon": "; ",
        "weekexam": "{count} exam(s) last week",

        // 新增课程设置完善需求
        "allname": "Full Name",
        "activeclass": "Available",
        "addclass": "Add Class",
        "alias": "Short name",
        "addalias": "Add class short name",
        "noclass": "No available class",
        "gotoset": "Jumping to course settings page…",
        "deleteclasstip": "All of the teaching activities will be deleted after deleting class",
        "deleteclasstip2": "All of the students will be removed after deleting class",
        "studenttotal": "Student Size",
        "activitytotal": "Teaching Activities",
        "classalias": "Class Short Name",
        "entername": "Please enter the name…",
        "setclassalias": "Set class short name",
        "archiveclasses": "Archive Class",
        "deleteclass": "Delete Class",
        "removearchive": "Remove archived class",
        "coteachernopermission": "No Permission",
        "pronopermission_rename": "This class name cannot be modified.",
        "pronopermission_del": "This class can only be deleted from the educational administration",
        "archiveconfirm": "Are you sure to archive?",
        "removearchiveconfirm": "Are you sure to remove?",
        "deleteclassconfirm": "Are you sure to delete?",
        "delfail": "Delete Failed. Please try again later",
        "coursename": "Course Name",
        "courseshortname": "Course Short Name",
        "delcourse": "Delete Course",
        "deletecoursetip": "Classes and teaching activities can’t be restored after deleting course",
        "coursetotal": "Class Numbers",
        "gotolist": "Jumping to course list…",
        "delcourseconfirm": "Are you sure to delete?",
        "classaliasmaxlength": "Class Short Name",
        "classnamemaxlength": "Class Name",
        "courseshortnamemaxlength": "Course Short Name",
        "coursenamemaxlength": "Course Name",
        "classshortnametip": "If you set a short name, it will be priority display.",
        "courseshortnametip": "If you set a short name, it will be priority display.",
        "protips": "This course is imported by the educational administration system, course data will be synchronized regularly.",
        "cannotrenamecourse": "This course name cannot be modified.",
        "cannotchangecoursetype": "The course type cannot be modified",
        "proclasstips": "This class is imported by the educational administration system, class data will be synchronized regularly.",
        "cannotchangeterm": "Semester information cannot be modified",
        "setcoursetype": "Please set course type first",

        // 完善信息检查入口
        'gocomplete': 'Complete',
        'completetitle': "Please complete your information",
        'completemsg': "According to national policy requirements, this operation needs to complete your information.",
        "gobind": "Bind",
        "authrealname": "Please bind your phone number",
        "bindphonetips": "According to national policy requirements, this operation needs to bind your phone number.",
    },

    // 试卷 主观题等
    quiz: {
        "showqusetion": "Show",
        "quizlocate": "Question {index}",
        "quizpoint": "Point:{score}",
        "datishic": "Duration:",

        "quiztext": "Text",
        "quizpic": "Picture",
        "quizvoice": "Voice Message",
        "quizadd": "Add",
        "quizvoicelimit": "9 voice messages at most",
        "quizback": "Back",
        "quizpreview": "Preview",
        "quizcorrect": "Correct Answer",
        "quizkeepedit": "Edit",
        "quizsubmit": "Submit",
        "quizsave": "Save",

        "quiztotalscore": "Total Score",
        "quizfullmarks": "Full Marks",
        "quiznogradesubjective": "Open Question: Not yet graded",
        "quizgradingsubjective": "Open Question: Grading...",
        "quizcheckobjective": "Objective Question",
        "quizcheckscore": "Score",
        "quizchecksubjective": "Open Question",
        "quiznotgraded": "Not yet graded",
        "curquiznotgraded": "本题未批阅",
        "seeannotation": "View comment",

        // 主观题作答
        "timeupnoanswer": "Time up. You can't answer it.",
        "quizanswer": "Answer",
        "scoreofthispro": "Score",
        "quizteachercomment": "Comment",
        "quizanswerkey": "Answer Key",
        "recording": "Recording...",
        "holdtotalk": "Hold to Talk",
        "releasetosend": "Release to Send",
        "confirmanswer": "Please confirm the answer.",
        "quizsubmitok": "Submit Successfully",
        "delpiccfm": "Are you sure to delete?",
        "delallpiccfm": "Are you sure to delete all?",
        "deltextcfm": "Are you sure to delete?",
        "delaudiocfm": "Are you sure to delete?",
        "delallaudiocfm": "Are you sure to delete all?",
        "quiznetworkerror": "Network unavailable, please check the system.",
        "imgIllegal": "The image may be violated, please check and try again.",
        "quizpiclimit": "9 pictures at most",
        "reuploadpiconly": "We only support picture formats, please try again.",
        "imagesizelimit": "Pictures should be less than 10 MB, please try again.",
        "accessrecord": "If you want to add audios, you should allow Rain Classroom to access to the microphone.",
        "takedifficult": "Unable to upload? Click here.",

        //主观题上传附件
        "upload_tip_mobil":"You can upload files on Rain Classroom web.",
        "attachment_file":"files",
        "add_attachment_file":"Upload Files",
        "upload_tip0":"Tips: maximum one file and the total size should be no more than 100M.",
        "upload_tip_quiz":"Tips: maximum one file and the total size should be no more than 300M.",
        "upload_tip1":"Check required format",
        "upload_tip2":"You can upload:",
        "file_uploading":"Uploading...",
        "file_upload_fail":"Failed",
        "file_upload_complete":"OK",
        "file_max_limit":"File size exceeds limit",
        "file_format_limit":"Unqualified Format",
        "downloadfile_tip":"Please use Rain Classroom web to download the files",

        //new
        "confirm_deletefile":"Are you sure to delete the file？",

        // 主观题批改页
        "graded": "Graded",
        "isgrading": "Grading",
        "quiznoanswer": "The student didn't answer this question.",
        "quiztotalpoint": "Total {sourceScore} Score",
        "quizentercomment": "Please enter comment",
        "good": "Good!",
        "comeon": "Great!",
        "uniqueidea": "Fabulous!",
        "excellent": "Excellent!",
        "required": "Required",
        "quizprevious": "Previous",
        "quiznextpro": "Next Question",
        "quiznext": "Next",
        "quizedit": "Edit",
        "quizcommentsaved": "The score and the comments will be saved automatically.",
        "quizaudio": "9 audios at most",
        "quizsubmitting": "Submitting",
        "quizshowquestion": "Show Question",
        "quizgradeinvite": "Please grade",
        "notgraded": "Not graded yet.",

        // 试卷反馈
        "finisheddetails": "Finished Details",
        "gradingdetails": "Grading Details",
        "submission": "Submission",
        "gradingtime": "Grading Time",
        "noonefinished": "No student has finished",
        "testfinisheddetails": "Test Completion",
        "finisheddetails": "Completion",
        "checktestpaper": "Checked",
        "graded": "Graded",
        "finishedtest": "Finished",
        "totalstudentone": "Total",
        "viewdetails": "View Details",
        "scoredistribution": "Score Distribution",
        "allvote": "Test Type: Polls",
        "ungradedsubjectiveproexist": "You still have ungraded Open questions.",
        "clickbarcharttograde": "Click bar chart of Open questions to grade.",
        "noonefinishedtest": "No student has finished.",
        "answerdetails": "Answer Details",
        "grading": "Grading",
        "deletepulishcfm": "Are you sure to delete?",
        "deletepublishfailed": "Delete Failed",
        // "standardopt": "The correct answer is:",
        "noanswerforpoll": "There is no correct answer for poll",

        // 客观题作答详情
        "anonymouspollnodetail": "This is an anonymous poll.",
        "numberofvotes": "{count} vote(s)",
        "standardopt": "The correct answer is:",
        "numberofstudents": "{count} student(s)",
        "noanswers": "No answers yet.",

        "loadingdata": "Loading",
        "answered": "Answered",
        "notansweredone": "Not answered",
        "gradeone": "Grading",
        // "": "条",
        "loadmore": "Load more",
        "okone": "OK",
        "positivescore": "Score must be positive.",
        "exceedmaximumscore": "Exceed maximum score, please try again.",
        "keepadecimal": "One decimal at most , please try again.",
        "numberonlywarning": "Numbers only, please try again.",
        "unclearstudents": '"Unclear" Students',
        "noquestiontoanswer": "The teacher didn't send any questions in this class.",
        "noquestiontoanswer": "The teacher didn't send any questions in this class.",
        "standardopt": "The correct answer is :",
        "noanswerforpoll": "No correct answer for the poll.",
        "gradingtime": "Grading Time",

        "timelimitedtest": "This is a time-limited test.",
        "min": "mins",

        "deadline": "Deadline",
        "testdeadline": "Test Deadline",
        "timelimitedtest": "This is a time-limited test.",
        "checkhw": "Check",
        "finishedhw": "Submitted Assignments",
        "hwfinisheddetail": "Assignment Completion",
        "finishedhwstudent": "{count}students have finished the assignments",
        "gradedhwnumber": "assignments have been graded.",
        "scorereport": "Score Report",
        "questionlocate": "Question {index}",
        "accuracyone": "Accuracy",
        "editpublishtitle": "Edit Title",
        "editpublishset": "Edit Set",
        "deletepublish": "Delete Publish",
        "deletepublishone": "Are you sure to delete?",
        "deletepublishfailed": "Delete Failed",
        "mailreceivedata": "Please type your email address to receive detailed data:",
        "enterfrequentmail": "Please write down your frequently used email address.",

        // 分组作答主观题
        "groupanswer": "Group Answer",
        "temporarygroup": "Temporary group",
        "submittips": "Each group has only one chance to answer the question, the answer can not be modified after submitting. Please have a fully communication before submitting",
        "check": "Back",
        "temporaryconfirm": "Are you sure to submit the answer as a temporary group (only yourself)?",
        "notingroup": "Not in any group",
        "contactteacher": "Contact the teacher to join a group or submit the answer in a temporary group (only yourself)",
        "iknow": "OK",
        "submitted": "The group has already submit the answer before you joined",
        "submitfail": "Failed",
        "onceTip": "Important",

        "gradetips": "Please grade open questions on Rain Classroom Web at {host}.",
        "entertext": "Enter text",
        'clicksave': 'Please save it in time after answering.',
        Return: 'Return',
        Returned: 'Returned',
    },

    // 课前预习 预习反馈 完成情况等
    cards: {
        'sensitive_words':'The input contains sensitive words, please check and try again',
        "dyzgtwpgs": "The ranking may not be the final version if open questions have not been revised.",
        "dfygdd": "Score (Descending)",
        "dfyddg": "Score (Ascending)",
        "qdsjpx": "Sign-In Time (Ascending)",
        "wszxh": "Not Set",
        "donealready": "Done",
        "checkedpreview": "Checked",
        "nocheckedpreview": "Not Checked",
        "noonefinishpreview": "No student has finished studied.",
        "noonepreviewing": "No student is studying.",
        "allfinish": "All students have finished.",
        "previewdetail": "Completion",
        "finisheddetails": "Completion",
        "finishedpreview": "Done",
        "checkslides": "Check Slides",
        "viewdetails": "View Details",
        "studentscheckedslides": "Students checked slides",
        "totalclassstudents": "Total Students",
        "answerdetails": "Answer Details",
        "subjectivepro": "Open Question",
        "gradingrate": "Grading Rate",
        "answerrate": "Answer Rate",
        "averagescore": "Average Score",
        "grading": "Grading",
        "webgradetips": "Tips: try a more convenient way to grade Open questions on Rain Classroom Web at {url}.",
        "accuracy": "Accuracy",
        "objectivequestion": "Objective Question",
        "answerrate": "Answer Rate",
        "teacherdatacheck": "Check",
        "studentfeedback": "Student Feedback",
        "anonymous": "Anonymous",
        "unread": "Unread",
        "nostudentfeedback": "No feedback.",
        "detaileddata": "Detailed Data",
        "webdownloadexcel": "Please download all Excel data on Rain Classroom Web at {url}.",
        "teachingdesign": "Instructional Design&Memo",
        "teachingdesigntip": "You can take notes here. (Private)",
        "teachingdesigntip2": "You can take notes here. (Private)",
        "editpublishtitle": "Edit Title",
        "editpublishset": "Edit Set",
        "deletepublish": "Delete Publish",
        "loadmore": "Load more",
        "mailreceivedata": "Please type your email address to receive detailed data:",
        "enterfrequentmail": "Please write down your frequently used email address:",
        "mailformaterror": "Email Format Error",
        "datasentok": "Sent Successfully",
        "yktwebtips": "Tips: on Rain Classroom Web at {url}",
        "deleteexcelnow": "You can download detailed Excel data directly.",
        "enternewtitle": "Please enter the new title.",
        "deletepulishcfm": "Are you sure to delete?",
        "deletepublishfailed": "Delete Failed",
        "previewdetails": "Details",
        "previewtips": "Not supported",

        // 学生预习课件
        "previewviewslides": "View Slides",
        "previewduration": "Duration:",
        "previewscore": "Score:",
        "finishstudy": "Complete:",
        "finishproblem": "Complete problems:",
        "wgky": "Not checked:",
        "answerdetails": "Answer Details",
        "previewungraded": "Ungraded",
        "previewnoquestion": "No questions in the contents.",
        "previewreporttoteacher": "Report to Instructor",
        "anonymous": "Anonymous",
        "unread": "Unread",
        "reporttoteachertip": "Feel free to report to your teacher if you have any questions~",
        "learningthoughts": "My Thoughts",
        "teachingdesigntip": "You can take notes here. (Private)",
        "previewhours": "{hour} hours",
        "previewmins": "{minuts} mins",
        "previewsecs": "{seconds} secs",
        "previewfeedbacktip": "Please write your feedback here.",
        "anonymoussend": "Anonymous Send",
        "previewcfm": "Confirm",
        "previewsending": "Sending",
        "previewentertip": "Please enter the content.",
        "sentok": "Sent Successfully",
        "sendfailed": "Send Failed!",
        "progress": "Progress: {depth}/{count}",
        "completionprogress": "{depth}/{count}",

        // 不懂收藏
        "unknownpagecount": '"Unclear" Pages',
        "unknowntotalpage": "Total Slides",
        "allslides": "Total",
        "problemslides": "Questions",
        "unknownslides": "Unclear",
        "viewresult": "Check",
        "slidesaudio": "Audio",
        "viewall": "Total Questions",

        "slidescomment": "Comment",
        "sendbtn": "Send",
        "commentfail": "Failed, please retry",
        "commenting": "loading",
        "commentok": "Success",

        // 小程序中网络视频提示
        "xcxzwfbfwlsp": "ERROR!",
        "qnzgzhgk": "Watch via Rain Classroom Official Account.",
        "rhcz": "HELP",
        "completionprogress": "{depth}/{count}",
        "miniprogramlinktip": "The external links cannot be opened in Mini Program. Please open them via Rain Classroom Official Account. ",
        "studentId": "Students ID",
        "progressinstruction": "Learning progress instruction:",
        "graphicpages": "1. The graphic pages",
        "watching3stocomplete": "When the courseware page contains only pictures and text, watching 1s is considered complete",
        "viewingmorethan1stocomplete": "When the courseware page contains only background picture and less than 20 words, viewing more than 1s is considered complete",
        "problempages": "2. The problem pages",
        "needtocompleteexercisestocomplete": "It means that the courseware page contains exercises and you need to complete the exercises to complete the study",
        "videopage": "3. The video page",
        "watchthevideotocomplete": "It means that the courseware page contains a video, and you need to watch more than 90% of the video to complete the study; <br/> If there are more than 1 video in a page, you need to watch 90% of all videos; Viewing time will not be counted by dragging",
        "specialinstructions": "4. Special instructions",
        "specialinstructionsdesc": "When the courseware page contains exercises and other categories, the completion of the courseware page is subject to the completion of exercises; <br/> When the courseware page contains videos and text, the completion of the courseware page is subject to the completion of the video",
        "inputPassword": "Please enter password",
        "inputPassword2": "Please enter a four-digit password",
        "password": "Password",
        "passwordIncorrect": "The password format is incorrect",
    },

    // 我的模块 主页 钱包 收藏 我的试卷 课件
    my: {
        "bonusexpenditure": "Bonus Expenditure",
        "withdraw": "Withdraw",
        "topup": "Top Up",
        "bonusincome": "Bonus Income",
        "bonusrefund": "Bonus Refund",
        "wallet": "Wallet",
        "bonus": "Bonus",

        "myyktwallet": "Wallet",
        "myslides": " My Slides",
        "mytests": "My Tests",
        "mysave": "Saved",
        "schoolbinding": "School Binding",
        "evaluation": "Evaluation",
        "reciveQuestionnaire": "我收到的问卷",
        "questionnairefeedback": "评价我的问卷",
        "editpersonalinfo": "Edit personal information",
        "saveinfo": "OK",
        "name": "Name",
        "nameeg": "Enter your name",
        "gender": "Gender",
        "gendermale": "Male",
        "genderfemale": "Female",
        "birthofdate": "Birth of Date",
        "role": "Role",
        "pleaseselect": "Please select",
        "student": "Student",
        "teacher": "Instructor",
        "otherrole": "Others",
        "school": "School",
        "schooleg": "Enter your school",
        "department": "Department",
        "departmenteg": "Enter your department",
        "company": "Company",
        "companyeg": "e.g. Tsinghua University",
        "studentid": "ID",
        "studentidnote": "Please write down Student ID",
        "email": "Email",
        "frequentemailnote": "Please write down Email",
        "finishok": "OK",
        "myhomepage": "My Homepage",
        "changesaved": "The change has been saved.",
        "uploadingimage": "Uploading image",
        "networkerror": "Network Error. Please check it.",
        "imageonly": "Only support image format, please try again.",
        "imagesizelimit": "Pictures should be less than 10 MB, please try again.",
        "profile": "Profile",
        "select": "Select",
        "cancel": "Cancel",
        "typeprofile": "Fill in the blank",
        "leavetrace": "Spend 30secs to leave your trace",
        "askforfeedback": "Help us improve by sharing your feedback.",
        "entername": "Enter your name",
        "enterschool": "Enter your school",
        "enterstudentid": "Please write down your Student ID.",
        "submitfailed": "Submission failed.",
        "connectionfailed": "Connection Failed, please try again later.",

        "bill": "Bill",
        "mybalance": "Balance",
        "topup": "Top Up",
        "withdraw": "Withdraw",
        "withdrawnotice": "Withdraw Notice",
        "questionwithdraw": "Q1: How to withdraw from the Wallet?",
        "answerwithdraw": "Click 『withdraw』in 『My Wallet』if your wallet balance is greater than ¥2 CNY. Money will be transfered to your Wechat Wallet in 3 days once submitted successfully.",
        "questioncharge": "Q2: Why charge 2% extra fee?",
        "answercharge": "This is the fee due to Wechat Transactions. RainClassroom won't make a profit from it.",
        "questionwithdrawlimit": "Is there a withdrawal upper limit?",
        "answerwithdrawlimit": "User can withdraw up to ¥2000 CNY per day due to Wechat limit.",
        "mywallet": "Rain Classrooom Wallet",
        "nobillfound": "No bill found",
        "thismonth": "This month",

        // 钱包新增
        "banktip": "Tips: instructor can use the money to send class bonus.",
        "bankhowbonus": "How to send class bonus?",
        "bankquestionwithdraw": "How to withdraw from the Wallet?",
        "bankanswerwithdraw": "Click 『withdraw』in 『My Wallet』if your wallet balance is greater than ¥2 CNY. Money will be transfered to your Wechat Wallet in 3 days once submitted successfully.",
        "bankquestioncharge": "Why charge 2% extra fee?",
        "bankanswercharge": "This is the fee due to Wechat Transactions. RainClassroom won't make a profit from it.",
        "bankquestionwithdrawlimit": "Is there a withdrawal upper limit?",
        "bankanswerwithdrawlimit": "User can withdraw up to ¥2000 CNY per day due to Wechat limit.",
        "bankclose": "Close",

        "today": "Today",
        "choosetopupamount": "Please choose top-up amount",
        "moreamountchoice": "More",
        "entertopupamount": "Please enter top-up amount",
        "back": "Back",
        "confirmtopup": "Confirm",
        "tipsinwallet": "Tips",
        "yktbalanceuse": "The balance can be used to send bonus or purchase open classes.",
        "enterwithdrawamount": "Please enter withdrawal amount.",
        "currentbalance": "Balance: {balance} CNY",
        "confirmwithdraw": "Confirm",
        "withdrawrules": "Withdraw Rules",
        "withdrawtips": "Tips: 2% of the withdrawal amount will be charged.",
        "rechargetips": "Tips: Users should recharge no more than ¥10000 CNY each time.",
        "transfertimetips": "Money will be transfered to your Wechat account in 3 weekdays.",
        "failtowithdraw": "Failed. The withdrawal limit is ¥2000 CNY per day.",
        "decimalwarning": "Sorry, the amount should not be decimal.",
        "withdrawmin": "User should withdraw no less than ¥2 CNY per day.",
        "insufficentbalance": "Sorry, insufficient balance in your wallet.",
        "balanceerror": "Balance Error",
        "systemerror": "System Error",

        "morningsaves": "No saved content found",
        "morningwords": "Morning Time-Words",
        "morningpoem": "Morning Time-Poems",
        "morningbooks": "Morning Time-Books&Films",
        "anonymous": "Anonymous",
        "answer": "Answer",
        "mysave": "Saved",
        "addtag": "Add Tags",
        "myslides": "My Slides",
        "chosennumber": "{chosenNumber} Selected",
        "selectall": "Select All",
        "confirmdelete": "OK",
        "choosemoreslide": "Please select at least one slide.",
        "deleteslidescfm": "Are you sure to delete?",
        "plugintips": "Tips",
        "manage": "Manage",
        "delete": "Delete",
        "noslidesfound": "No slides found",
        "pluginykt": "Try Rain Classroom plug-in in your computer",
        "mytests": "My Tests",
        "notest": "No test found",
        "deletetestcfm": "Are you sure to delete?",
        "medeletetestfailed": " Delete Failed",

        //后补充
        "medelslidescfm": "Are you sure to delete?",
        "medelslidesfailed": "Delete Failed",
        "tips": "Tips",
        "chooseonemoretest": "Please choose at least one test.",
        "medelquiz": "Are you sure to delete?",
        "mewallettopup": "Top Up",
        "mewithdraw": "Withdraw",
        "withdrawmorethantwo": "User should withdraw no less than ¥2 CNY.",
        "receivedanddeducted": "Received ${getMoney}, deducted commission ${fee}.",
        "ykttopup": "Rain Classroom-Top Up",
        "mebill": "My Bill",
        "meupdatingprofilepic": 'Updating profile photo',
        "merealname": 'Name',
        "meschoolbelongs": 'School',
        "merole": 'Role',
        "meteacher": 'Instructor',
        "meothers": 'Others',
        "mestudentid": 'Student ID',
        "schoolstudent": 'Student',
        "schoolteacher": 'Instructor',
        "universitybelongs": 'School',
        "userunbind": 'Unbind',
        "addschool": 'Add a school',
        //设置语言新增
        "setting": 'Setting',
        "selectlang": 'Language',
        "savelang": 'Save',
        "savinglang": 'Setting...',
        "savesuccess": 'Successful',

        // 个人信息完善
        'infocosttime': 'Fill in your personal information in 30sec',
        'infogood': '',
        'infogoodteacher': '',
        'infoorg': 'Organ.',
        'infoorgtip': 'Not required',
        'infonumbereg': 'Please write down your Student ID',
        'infotip': 'You can change the information at any time in "My Homepage"',
        'backtomini': 'Saved. Please go back and pull down to release.',
        'backtominiok': 'I know',

        // 支付提示
        'payfailtip': 'Please top up on Rain Classroom Official Account.',
        "storeboards": "Saved Board（Total {total}）",
        // 学校绑定列表
        'moreSchool': 'More schools to add…',

        // 通用账号密码设置
        'accountsetting': "Account and Binding Settings",
        'gosetting': 'Set',
        'languagelabel': 'Language',
        'language': 'English',
        'subscribe_manage': '订阅通知管理',
        'hasbeenset': 'Set',
        'wechat': 'WeChat',
        'phone': 'Phone',
        'gobind': 'Bind',
        'email': 'Email',
        'password': 'Password',
        'settips': '* After binding the mobile phone number/Email and setting the password, you could use “account + password”to log in to the RainClassroom and the XuetangX website.',
        'settips_thu': '* After binding the mobile phone number/Email and setting the password, you could use “account + password”to log in to the Lotus Pond.',
        'settips_changjiang': '* After binding the mobile phone number/Email and setting the password, you could use “account + password”to log in to the Changjiang Rainclassroom',
        'settips_huanghe': '* After binding the mobile phone number/Email and setting the password, you could use “account + password”to log in to the Huanghe Rainclassroom',
        'bindemail': 'Bind Email',
        'emailplaceholder': "Email Address Here",
        'verifyplaceholder': 'Verification Code Here',
        'getcode': 'Get Code',
        'bind': 'Bind',
        'verifycodeerror': 'Verification code error',
        'emailerror': "Please enter a valid Email address",
        'bindsuccess': "Success",
        'hasbound': 'This Email has been bound before',
        'youhavebound': 'You have bound a Email',
        'replaceemail': 'Replace the bound',
        'setpassword': 'Set Password',
        'reenter': 'Re-enter',
        'confirm': 'Confirm',
        'changepassword': 'Change Password',
        'oldpassword': 'Old Password',
        'newpassword': 'New Password',
        'enter': 'Enter',
        'oldpassworderror': 'Old Password Error',
        'newpassworderror': 'New passwords are inconsistent',
        'setsuccess': 'Success',
        'lengthlimit': '8-16 characters，contains  numbers and upper and lower case letters.',
        'phoneerror': 'Please enter an available number',
        "bindPhone": "Bind Phone",
        "bound": "You have bound a phone number",
        "replacePhone": "Replace the Bound Number",
        "bindPhone2": "Bind Phone",
        "verifiplaceholder": "Verification Code Here",
        "getVerificationCode": "Get Code",
        "bind": "Bind",
        "regain": "Regain",
        "lawtips": "Real-name authentication is required by law. Please bind your phone number to ensure the availability and security of your account.",
        "second": "s",
        "receivecode": "Can't receive the verification code",
        "extractminiprogram": "Extract the mini program code to bind the phone",
        "closewindow": "Close this window after binding complete",
        "pleasebindfirst": "Please bind first",
        "wrongemail": "Wrong format",
        "wrongphone": "Wrong format",
        "emailhasbond": "Email has been bond",
        "codeexpired": "Code expired",
        "wrongcode": "Wrong code",
        "wrongoldpassword": "Wrong old password",
        "invalidnewpassword": "Invalid new password",
        "codefailedtobesent": "Code failed to be sent",
        "forgetpassword": "Forget password?",
        "resetpassword": "Reset password",
        "verifyphonenumber": "Verify phone number",
        "besenttotheboundphonenumber": "Verification code will be sent to the bound phone number",
        "pleasebindyourphonefirst": "Please bind your phone first",
        "notblankspaces": "Password cannot include blank spaces",
        "ruleerror": "Wrong password format",
        "notchinese": "Password must not contain Chinese.",
        "minlength8": "Password must be 8-16 characters.",
        "errornewpassword": "Unqualified password. Please try again.",
        "bindthirdaccount": "Bound third-party account",
        "txmeet": "Tencent meeting",
        "gotobind": "Go to bind",
        "changebindtitle": "This mobile phone number has been bound to another {env} account. If you continue to operate, the original account will be automatically unbound. Whether to continue?",
        "changebinddesc": "Tips:After changing the binding, the original account will not be able to use the mobile number to log in, You may not be able to access the original account data.",
        "smscodeerr": "Verification code error",
        "samephone": "The phone number is the same as the currently bound phone number",
        "xuetangoryktsamephone": "This mobile number has been bound to another account",
        "checkcourselist": "View {count} courses",
        "accountnocourse": "The account has no course selection. It is recommended to change to the current account.",
        "originaccountjiebang": "The original account (ID {id}) will be unbound. If it is not bound to WeChat/Email and other login methods, the original account will not be able to log in. Do you want to continue?",
        "mergeaccount": "It is recommended to merge data into this account (ID {oid}). After merging, the current account (ID {nid}) will be discarded, and all your course selection and learning data will be retained.",
        "continuenext": "",
        "merge": "Merging",
        "changebind": "Changebind",
        "coursecount": "(ID {id}) There are {count} classes",
        "ykt": "Rainclassroom",
        "teach": "Managed",
        "learn": "Joined",
        "xuetangx": "xuetangX",
        "mergeerror": "Account consolidation cannot be performed. Please change the phone number and rebind.",
        "bindemailtologin": "Please bind mailbox for ID {id}",
        "notbindemail": "No mailbox, I want to discard ID {id}",
    },

    // 预约发布 试卷发布
    publish: {
        "scheduledeliverfailedone": "Scheduled deliver failed, please try again.",
        "publishname": "Publish Name",
        "quizone": "Quizzes",
        "timetopublish": "Time to publish",
        "deadlineone": "Complete deadline",
        "quizdurationone": "Quiz Duration (mins)",
        "quizdurationone2": "Quiz Duration",
        "releasetimeone": "Time to release answer",
        "publishclassone": "Class",
        "totalclassesone": "Total Classes: {length}",
        "deletepublishone": "Are you sure to delete?",
        "cancelone": "Cancel",
        "okone": "OK",
        "delete": "delete",
        "confirmone": "OK",
        "publishinstruction": 'How to publish {name}',

        "setdeadlinetips": "If complete deadline is set, students will not able to answer questions, and the data will not be updated, but slides can still be viewed within the view deadline;",
        "nosetdeadlinetips": "If complete deadline is not set, students can view the slides and answer the questions at any time during the view deadline, and the data will be updated in real time; ",
        "systemsubmitanswers": "After the deadline, students can still check the answers, but unable to answer or submit. The test data and score distribution will not be updated, and students' answers will be submitted automatically.",
        "timernostop": "Students must submit answers by the deadline. The timer will not stop if you exit. Students' answers will be submitted automatically at the end of test.",
        "releasetips": "The correct answers will be released after the selected time. Until then, students will not be able to know the answer key.",
        "releasetips_col": "The correct answers will be released after the selected time. Until then, students will not be able to know the answer key.",
        "close": "Close",
        "publish": "Release",
        "publish1": "Publish",
        "none": "None",
        "publishnow": "Publish Now",
        "nowtime": "Current Time",
        // "": "["日","一","二","三","四","五","六"]", Sun. Mon. Tue. Wed. Thu. Fri. Sat.
        "notimelimitone": "No Time Limit",
        "showaftersubmission": "Show after submission",
        "showaftersubmission_col": "Show after submission",
        "nochooseclass": "You haven't chosen a class to publish",
        "publishtimenoearliernow": "No earlier than current time.",
        "ddltimenoearliernow": "No earlier than current time.",
        "ddltimetip": "Invalid time! Please reset the deadline.",
        "testdurationzero": "Test duration can't be 0",
        "noearlierthanpublishtime": "No earlier than publish time. \r\n Please reset.",
        "changecfmone": "Are you sure to change?",
        "publishcfmone": "Are you sure to publish?",
        "deletecfmone": "Are you sure to delete？",
        "hour": "Hour",
        "min": "Min.",
        "min1": "",
        "hour2": "Hour",
        "selecttime": "Select Time",
        "today": "Today",
        "tommrrow": "Tomorrow",
        "thedayaftertommorrow": "The day after tomorrow",
        "monthdayweek": "month day week",

        "hasbeensent": "",
        "classes": "classes have received",
        "failSendClasses": " class(es) have received",
        "sendLoading": "loading...",
        "sendWaitTip": "It takes longer to wait in the queue when there are a lot of courseware being sent.",
        "sendWaitPlease": "Close this page, does not affect your sending<br/>After successful sending, we will send a notification to your WeChat</br> Please do not repeat the operation to avoid congestion.",

        // 课下主观题分组作答
        "answerway": "Ways of Answer",
        "totalgroup": "{count}groups",
        "changegroup": "Change",
        "nogroup": "No Grouping",
        "archivetips": "You have to remove the classrooms from the Archive",
        "answerwaydesc": "When the slides contains open questions and the target class has at least one group, you can select the group answer.All open questions in the slides will be answered according to the selected group",
        "hassubject": "Just all open questions are allowed to answer by groups",
        "nosubject": "There is no open question in the slides",
        "answerway_person": "Personal Answer",
        "nogrouptips": "There is no groups in the class, add group first or choose personal answer",
        "choosegroup": "Select",
        "maximum": "Select a maximum of 5 classes",
        "coursewarecheckauth": "Permission of view courseware",
        "endnolimit":  "Invisible when finished",
        "setimelimit": "Invisible after setting time",
        "coursewarechecktime": "View deadline",
        "checklimitneed": "Please select viewing time",
        "checklimitnow": "Viewing time cannot be earlier than current time.",
        "checklimitpub": "Viewing time cannot be earlier than publish time.",
        "checklimitdeadline": "Viewing time cannot be earlier than deadline.",
        "curpptnotcheck": "The courseware can not be viewed at present.",
        "curpptnotcheckbr": "The courseware can<br/>not be viewed at present.",
        "exercisenocheck": "The exercise can not be viewed at present.",
        "curexercisenocheck": "The exercise can not be viewed at present.",
        "answertimedeadline": "Announce the answer time >= deadline",
        "setpptchecktips": "If view deadline is set, students will not able to view the slides;",
        "changepptchecktips": "After changing view deadline，it will be applied to all students",
        "limited": "Limited",
        "applyforthepermission": `The previous teaching activities have been completed. If you need to continue teaching in a large class, please contact <span style="font-weight: bold;">yuketang@xuetangx.com</span> to apply for the permission.`,
        'viewhelp': 'View help'
    },

    //学生小结
    student: {
        "way_qrcode": "Scan QR code",
        "way_invite_code": "Class Code",
        "way_inclass_tips": 'Class Tip',
        "way_other": "Other",
        "minishare": "MiniProgram Share",
        "viewplayback": "Replay",
        "manualmark": "Manual mark",
        "lessonreminder": "Lesson Reminder",
        "tencentmeeting": "Tencent meeting",
        "transcript": "Transcript",
        'joinclassInfo': 'You enter the class at <span class="blackText">{time} </span>by“<span class="blackText">{way}</span>”',
        "noquestions": "No questions here",
        "personalscore": "Your Score",
        "averageclassscore": "Class Average",
        "timespent": "Your Time",
        "classaveragetime": "Class Average",
        "summarycorrectno": "Correct",
        "summarywrongno": "Wrong",
        "summaryungraded": "Ungraded",
        "questionsnumber": "Questions Number",
        "unclearslides": "Unclear",
        "savedslides": "Favorite",
        "markinclass": "Click ",
        "unclear": "Unclear",
        "and": " and ",
        "save": "Favorite",
        "afterclassreview": " for your after-class review",
        "noattendclass": "You haven't attended this class",
        "noattendbyteacher": 'You are absent from this class，noted by your teacher.',
        "tutorlesson": "Remember to learn it in time",
        "studycontent": "Study Content",
        "noreleasedslides": "Instructor didn't release any slide",
        "summaryquiz": "Quiz",
        "studentsummaryscore": "{score} points",
        "nowanswered": "Unanswered",

        "questiondetails": "Question Details",
        "wrongquestion": "Wrong Questions",
        "subjectivequestion": "Open Question",
        "fillblank": "Completion",
        "notanswered": "Unanswered",
        "youranswer": "Yours:",
        "loadmore": "Load more",
        "allcorrectcongrats": "Congrats, all your answers are correct.",
        "ungraded": "Ungraded",
        "correctanswer": "Correct:",
        "unclearslides": "Unclear",
        "studentsummarynounclearslides": "No unclear slides in this class.",
        "saveslides": "Saved slides",
        "summarynosavedslides": "No favorite slides in this class",
        "myposts": "My posts",
        "learningthoughts": "My thoughts",
        "writetips": "Write something",
        "brilliantstudent": "Brilliant Student",
        "amongbeststudents": "You're among the best students",
        "carryon": "Carry on",
        "underperformstudent": "Underperforming Student",
        "encourgestudent": "You can do better next time.",
        "cheerup": "Cheer Up",
        "summaryallquestions": "All Questions",
        "previewdetails": "Preview Details",

        "pagetotal": "Total Slides:{count} ",

        //查看习题
        "nounderstandslide": "No Unclear slides",
        "pageno": "Page{page}",
        "subject_noanswer": "Not answered.",
        "fillblank_noanswer": "Not answered.",
        "seedetail": "View Details",
        "thisanswer": "The correct answer is:",
        "nosentclass":'Not send in class',
        "thisresult": "Your Answer:",
        "no_answer": "Not answered yet.",
        "answer": "Answer",
        "correct": "Correct",
        "wrong": "Wrong",

        //查看PPT
        "allslides": "Total",
        "nostoreslide": "No favorite slides.",
        "toup_noanswer": "No correct answers for poll.",
        "fullscreenexit": "Click the black area to exit.",

        //查看学生主观题详情页
        "myscore": "Score(Total{score})）",
        "score": "", //保持为空
        "remark": "Comment",
        "no_setscore": "Not graded yet.",
        "answeranaly": "Answer Key",
        "seeanaly": "Answer Key",
        'acrossSingleChoice':'Please check your answer under portrait mode',
        "myanswer": "My Answer",
        "close": "Close",
        "answertype_group": "Groups",
        "newscore": "Score",
        "blanksnotanswer": "Not all of the blanks had been filled. Are you sure to submit?",

        "screenshot": "Screenshot",
        "blackboard": "Blackboard writing",
        "lessonshare": "Share",
        "liveplayback": "Replay",
        "boardplayback": "Replay",
        "haveliveclickcheck": "View live playback of this lesson",

        'fulltext': "Full text",
        'fold': "Collapse",

        // 学生接收器回放
        "undone": "Undone",
        "done": "Done",

        "pno": "Page {number}",
        "totalprob": "Total Questions:{number}",

        "unknown": "Unclear",
        "favorite": "Favorite",

        "newprob": "Hi, you have a new question",
        "newvote": "Hi, you have a new vote.",
        "recvbonus": "Hi, answer the question correctly and bonus awaits you!",
        "gainbonus": "{number} students won bonus.",
        "cantintoteam": "The co-instructor does not belong to any groups.",
        "cantintoteam2": "No authority",

        "sharepostpush" : "Hi, the teacher is sharing post.",
        "sharesubjective" : "Hi, the instructor posts an answer.",
        "randomized": "Random grouping is launched",
        "freegrouping": "Free grouping is launched",
        "launchedgrading" : "A peer grading is launched.",
        "viewresults": "check",
        "enterpassword": "Enter a password",

        // socket event
        "LESSON_START": "Start Class!",
        "SHOW_PRESENTATION": "New Slide: {0}",
        "LESSON_FINISH": "End Class!",
        "DANMU_ON": "Danmu On",
        "DANMU_OFF": "Danmu Off",
        "RANDOM_PICK": "Random Roll Call: {0}{1}",
        "SHOW_FINISH": "End Show",
        "QUIZ_FINISH": "The quiz has been collected.",
        "FREE_GROUP_CANCEL": "Free grouping has been cancelled",
        "RANDOM_GROUP_CANCEL": "Random grouping has been cancelled",
        "LIVE_ON": "Live On",
        "LIVE_OFF": "Live Off",
        "INTERACTIVE_ON": "Interactive On",
        "INTERACTIVE_OFF": "Interactive Off",
        "TencentInteractive_ON": "Tencent Meeting is on.",
        "TencentInteractive_OFF": "Tencent Meeting is off.",

        "howtoprint": "How to Print",
        "added": "Added",
        "canceled": "Cancel",
        "cannotbecanceled": "Unclear slides cannot be cancelled",
        "nothinghere": "Nothing here~",

        // 回放相关
        "videotranscoded": "Playback video is being transcoded, please try later",
        "waiting": "The playback generation will be slow. Please wait patiently ~",
        "audioplayback": "Audio playback",
        "set": "Set",
        "definition": "Definition",
        "high": "High",
        "standard": "Standard",
        "smooth": "Smooth",
        "speed": "Speed",
        "playback": "Class live playback",
        "watchplayback": "Watch class live playback",
        "fold": "fold",
        "play": "Play",
        "backtocurrent": "Back to current position",
        "audiotranscoded": "Playback audio is being transcoded, please wait...",
        "reload": "Try to visit or reload this page later ~",
        "board": "Board",
        "dataabnormal": "Data abnormal",
        "cannotaccesstencent": "Unable to access the Tencent Meeting replay，please replace the playback via Manage Live Replay-Replace playback on webside.",
        "cannotaccesstencentstu": "Unable to access the Tencent Meeting replay , please contact teacher to go to the  Manage Live Replay on webside to replace the playback.",
        // 回放管理
        "manage": "Manage",
        "audiospeed": "speed",
        "savecloud": "save to cloud",
        "downloadtip": "please download replay on Web",
        "deleteurl": "delete replay",
        "allcheck": "all",
        "replayurl": "replay",
        "duration": "Play Time",
        "saving": "saving",
        "offload": "offload",
        "nonsupport": "nonsupport",
        "iknow": "I know",
        "notvip": " you're not a member",
        "viptip": `You cann't save to cloud unless you are a vip member. You can  follow "雨课堂" on wechat,  send "VIP" and click the received link to apply.`,
        "tips": "tips",
        "issaviing": "The replay is being  saved to cloud, please check it in the cloud later",
        "spacefull": "Storage space is full",
        "fulltip": "The space is full, you can try again after you have cleared enough space",
        "deleteallreplay": "Are you sure to delete all replays?",
        "deletealltip": "After deletion, neither teachers nor students can watch the replay , and it cannot be recovered",
        "deletereplay": "Are you sure to delete the  replays?",
        "deletetip": "After deletion, neither teachers nor students can watch the replay , and it cannot be recovered",
        "deletesuccess": "Delete Success",
        "servicenonsupport": "The service provider does not support it",
        "servicenonsupportdel": "The current replay can not be deleted",
        "servicenonsupporthidden": "The current replay can not be hidden",
        "repeatsave": "Please do not repeat submit",
        "checkinweb": "It has been saved, please check it in the Web cloud",
        "replayisprocessed": "replay is being processed please save later",
        "playtype1": "[audio]",
        "playtype2": "[video]",
        "noaccess": "Sorry, you do not have administrative rights, you can contact the lecturer to manage.",
        "setviewstatus": "Set visible state",
        "playbackentry": "Entrance of playback",
        "audioplayback": "Audio playback",
        "videoplayback": "Video playback",
        "confirmcloseentry": "Are you sure to close the entrance of playback?",
        "closeentryresult": "Students will not be able to watch all playback paragraphs after closing.",
        "confirmhiddenplayback": "Are you sure to hide the playback paragraph?",
        "hiddenresult": "The playback paragraph will not be visible to students after hiding.",
        "setsuccess": "Set successfully",
        "playbackallhiddentip": "* All playbacks of this lecture are currently unavailable",
        "cannotplaycuritem": "The current playback paragraph has been hidden or deleted, locating function cannot be used",

        // 新试卷封面
        "exam_desc": "Information for Candidates",
        "nodesc": "No tips",
        "score_finished": "My score",
        "score_unstart": "Score",
        "wrongproblems": "Errors",
        "datishu":"Groups",
        "xitishuliang":"Questions",
        "problems": "Questions",
        "exam_notanswer": "No answer",
        "start_time": "Start Time",
        "end_time": "Deadline",
        "end_lesson_time": "结课时间",
        "exam_limit": "Duration",
        "exam_notlimit": "No limit",
        "answer_time": "Score will be released after {time}",
        "exam_start": "Start exam",
        "exam_continue": "Continue answering",
        "exam_notbegin": "Not started",
        "exam_check": "Check quiz",
        "exam_nodata": "暂无数据",
        "exam_notview": "Invisible when submitted",
        "sun": "Sunday",
        "mon": "Monday",
        "tue": "Tuesday",
        "wed": "Wednesday",
        "thu": "Thrusday",
        "fri": "Friday",
        "sat": "Saturday",
        "watchedreplay": "You have watched the class replay",
        "partpagenoview": "部分页面当前已不可见",
        "coverentertips": "Unable to start the examination",
    },

    //消息
    message: {
        "infoassignment": "Assignments",
        "infomessage": "Messages",
        "infofollowers": "Followers",
        "chat": "Chat",
        "comment": "Comment",
        "repliedToYou": "replied to you",
        "commentedOnYourComment": "commented on your comment",
        "likedYou": "liked you ",
        "NoMessage": "No Message",
        "loading": "Loading",
        "nomessage": "You have no messages.",
        "infocoteacher": "You have became a co-teacher.",
        "removecoteacher": "You have been removed as a co-teacher.",

        "infopromotecoteacher": " {courseTitle} 's leading teacher has made you the co-teacher.",
        "inforemovecoteacher": "{courseTitle} 's leading teacher has removed you from co-teacher.",
        "receivepreclassinfo": "Received preview feedback.",
        "inforeceivereport": "received {feedbackCnt} preview messages, please check.",


        "replypreviewreport": "received a teacher's reply.",
        "receiveteacherreply": "received a teacher's reply, check it!",

        "pullRefresh": "Pull down",
        "releaseUpdate": "Release",
        "markasread": "Mark as Read",
        "hasMarked": "All marked as read",
        "message": "Message",
        "notification": "Notification",

        "infonofollowers": "You have no followers.",
        "infoyourquestionanswered": "{respondent} answered your question.",
        "infoquestionname": "The question is {question}",
        "inforeplytou": "replied to you",

        "noassignment": "You have finished all assignments.",
        "publishslidespush": " {teacherName} published new slides.",
        "published": " has been published",
        "slidesddlpush": "Deadline: {deadline}",
        "previewpush": "Please finish before {deadline}",
        "unclearremind": "You have unclear slides.",
        "figureoutunclears": " Figure out the unclear slides. You can do it!",
        "publishquizpush": " Instructor {teacherName} published a new test.",
        "publishedpush": "  please check it.",
        "assignmentddlpush": "Please finish before {deadline}.",
        "inforeceiveslidespush": "Start to study {courseTitle}-{chapterTitle}{sectionTitle}~",
        "unclearset": "Students' Unclear Slides Set",
        "checkstudentunclear": "Check students' unclear slides!",
        "infobeinvited": "{inviter} invites you to answer a question.",

        "booking_down": "The open class you booked has updated.",
        "image": "pic",
        "NoMessageTips": "You can chat with others by clicking members' photos on member list.",
        "commentdel": "comment deleted"
    },

    // 教师端页面
    teacher: {
        "yijiaojuan": "Submitted",
        "weijiaojuan": "Unsubmitted",
        "unclearlist": "“Unclear” List",
        "standardopt": "The correct answer is :",
        "nameone": "Name",
        "optionone": "Option",
        "notansweredone": "Not Answered.",
        "wrongquestionone": "Question Wrong",
        "slidewrongone": "Slide Unclear",
        "studentnumber": "Number of students",
        "wrongone": "Wrong",
        "unclearone": "Unclear: ",
        "uncleartwo": "Unclear",
        "searchone": "Search",
        "rankingone": "Ranking",
        "totalscoreone": "Scores",
        "timespentone": "Time Spent",
        "questionandpage": "No.",
        "tihao": "No.",
        "correctanswertwo": "Correct Answer",
        "submitone": "Submit",
        "submit": "Submit",
        "correctanswerthree": "Correct Answer",
        "scoreone": "Score",
        "subjectivequestionone": "Open question",
        "inclassquiz": "In-class Quiz",
        "notansweredtwo": "Not Answered",
        "notansweredblanks": "Not answered",
        "detailsone": "Details",
        "checkone": "Check",
        "sentokone": "",
        "sentoktwo": "Sent successfully:",
        "scheduledeliverfailedone": "Scheduled Deliver failed, please try again.",
        "publishname": "Publish Name",
        "quizone": "Quizzes",
        "timetopublish": "Time to publish",
        "timetopublish1": "Time to release",
        "deadlineone": "Deadline",
        "quizdurationone": "Quiz Duration (mins)",
        "releasetimeone": "Time to release answer",
        "publishclassone": "Class",
        "totalclassesone": "Total Classes: {length}",
        "pagetotal": "Total Slides:{count} ",
        "deletepublishone": "Are you sure to delete?",
        "cancelone": "Cancel",
        "okone": "OK",
        "delete": "delete",
        "confirmone": "ok",
        "publishinstruction": "How to publish {\"quiz\" : \"slide\"}?",
        "setdeadlinetips": "If you set the deadline, students can still check the slides after the deadline, but not able to answer questions. And the data is no longer updated.",
        "nosetdeadlinetips": " If you do not set the deadline, students can check the slides and answer questions at any time, and the data will be updated in real time.",
        "systemsubmitanswers": "After the deadline, students can still check the answers, but unable to answer or submit. The test data and score distribution will not be updated, and students' answers will be submitted automatically.",
        "timernostop": "Students must submit answers by the deadline. The timer will not stop if you exit. Students' answers will be submitted automatically at the end of test.",
        "releasetips": "The correct answers will be released after the selected time. Until then, students will not be able to know the answer key.",
        "close": "Close",
        "publish": "Release",
        "none": "None",
        "publishnow": "Release Now",
        "": "[\"Sun.\",\"Mon.\",\"Tue.\",\"Wed.\",\"Thu.\",\"Fri.\",\"Sat.\"]",
        "notimelimitone": "No Time Limit",
        "showaftersubmission": "Show after submission",
        "nochooseclass": "You haven't chosen a class to publish",
        "publishtimenoearliernow": "No earlier than current time.",
        "ddltimenoearliernow": "No earlier than current time.",
        "testdurationzero": "Test duration can't be 0",
        "noearlierthanpublishtime": "No earlier than publish time. \\r\\n Please reset.",
        "changecfmone": "Are you sure to change?",
        "publishcfmone": "Are you sure to publish?",
        "deletecfmone": "Are you sure to delete？",
        "hour": "Hour",
        "min": "Min.",
        "min1": "Min.",
        "hour1": "",
        "today": "Today",
        "tommrrow": "Tomorrow",
        "thedayaftertommorrow": "The day after tomorrow",
        "tips1": "Tips: you can release answers at a certain time.",
        "chengjidantips": "The system will automatically calculate points according to the assessment settings. You can view and manage assessment program on the web.",
        "monthdayweek": "month day week",
        "anonymouspollnodetail": "This is an anonymous poll.",
        "numberofvotes": "{count} votes",
        "standardopt": "The correct answer is:",
        "numberofstudents": " {count} student(s)",
        "numberofstudents1": "student(s)",
        "noanswers": "No answers yet.",
        "answerdetails": "",
        "submittime": "Submit Time",
        "numberviewedpage": "Page viewed",
        "content": "Content",
        "senttime": "Sent Time",
        "saved": "Saved",
        "save": "Save",
        "whatispost": "What is Post?",
        "post": "Post",
        "coteacherinclass": "Co-instructor",
        "addcoteacher": "Add Co-instructorr",
        "setpermission": "Set Permission",
        "deletepermissioncfm": "Are you sure to delete?",
        "deletepermissionfailed": "Delete Failed",
        "selectall": "Select All",
        "confirmdelete": "Confirm",
        "": "You can only manage guest students.",
        "managestudents": "Manage Students",
        "clear": "Clear",
        "readnumber": "read",
        "unreadnumber": "unread",
        "slidecover": "Slide Cover",
        "slidename": "Slide Name",
        "yearmonthday": "year month day",
        "selectclass": "Select Class",
        "done": "Done",
        "addnewclassinjoined": "Click \"Manage\" to add a new class",
        "enterslidetitle": "Please enter the slide title",
        "noclasschosen": " You have not chosen a class to publish.",
        "publishfailed": "Publish Failed",
        "selectclasstopublish": "Select class to publish",
        "nocreatedcourse": "You have not created a course.",
        "createaacourse": "Create Course",
        "publishname": "Publish Name",
        "noclassyet": "No class in this course, please add a class.",
        "tocreatecourse": "Create Course",
        "cfmpublish": "Confirm",
        "enterslidetitle": "Please enter slide title",
        "selectclassplease": "Please select class",
        "announcementlimit": "You can only send two announcements for each class per day, you can still send _.",
        "anouncementnumbers": "announcements",
        "requiredtitle": "Title (required)",
        "spaceorentertosend": "You can send texts, images, links to students (please add a space or press Enter to confirm before and after entering the link address)",
        "sendto": "Send to：",
        "backtoedit": "Back to edit",
        "confirmok": "OK",
        "classesreceiveok": "It has been successfully sent to the following classes:：",
        "gotit": "Got it",
        "deletepiccfm": "Are you sure to delete？",
        "quiteditcfm": "Discard the changes?",
        "noannouncementcansend": "You can send 0 announcement.",
        "titlenotnull": "The title should not be null.",
        "announcementnotnull": "The announcement should not be null.",
        "reachupperlimit": "Unable to send. Reached the upper limit.",
        "announceanswertip": "Tips: The answer will be announced after this date, otherwise it will be displayed directly after submission.\n",
        "notimelimitdetail": "No Time Limit. 5 mins 15 mins 30 mins 45 mins 60 mins 90 mins 120 mins 150 mins 4 hours 6 hours 8 hours 2 hours 24 hours 48 hours.",
        "enterquizname": "Please enter the test name",
        "setdateaftertoday": "Please set a date after today",
        "teachingdatapoll": "Poll",
        "chooseupperlimit": "Choose no more than ...",
        "teachingdataoption": "Option",
        "multiplem": "Multiple Choice (multiple)",
        "multiples": "Multiple Choice (single)",
        "subjectivepro": "Open Question",
        "point": "Point",
        "anonymouspollnodetail": "This is an anonymous poll.",
        "votenumber": "votes",
        "standardopt": "The correct answer is",
        "notansweredone": "Not answered",
        "teacherdatastudents": "students",
        "teacherdatastudentscount": "{count}student(s)",
        "weidatitishi": "*Unanswered questions do not include students who are not signed in.",
        "zuodashichang": "Length of response time",
        "noanswers": "No answers yet.",
        "answerdetails": "Answer Details",
        "noaddslides": "You have not added any slides yet.",
        "selectslideoneonly": "Select Slide (1 only)",
        "coursechooseslide": "Select Quiz (1 only)",
        "year": "Year",
        "month": "Month",
        "day": "Day",
        "publishname": "Publish Name",
        "deadline": "Deadline",
        "enterslidenameplease": "Please enter slide title",
        "datedetail": "／ ／",
        "cfmpublish": "Confirm",
        "slidepublish": "Publish",
        "sending": "Sending",
        "noaddtests": "You haven't added any tests yet.",
        "selectslideoneonly": "Select Slide ( 1 only )",
        "sendnow": "Send Now",
        "testduration": "Duration(mins)",
        "notimelimitone": "No Time Limit",
        "releasetimeone": "Time to release answer",
        "showaftersubmission": "Show after submission",
        "announceanswertip": "Tips: The answer will be announced after this date, otherwise it will be displayed directly after submission.",
        "cfmpublish": "Confirm",
        "publishtest": "Publish Test",
        "setdateaftertoday": "Please set a date after today.",
        "sending": "Sending",
        "notimelimitdetails ": "No Time Limit 5mins 15mins 30 mins 45mins 60 mins 90mins 120mins 150mins 4hours 6hours 9hours 12hours 24hours 48hours",
        "donealready": "Done",
        "checkedpreview": "Checked",
        "nocheckedpreview": "Not Checked",
        "noonefinishpreview": "No student has finished studied.",
        "noonepreviewing": "No student is studying.",
        "allfinish": "All students have finished.",
        "previewdetail": "Completion",
        "finisheddetails": "Completion",
        "finishedpreview": "Done",
        "checkslides": "Check Slides",
        "viewdetails": "View Details",
        "studentscheckedslides": "Students checked slides",
        "totalclassstudents": "Total Students",
        "answerdetails": "Answer Details",
        "subjectivepro": "Open Question",
        "gradingrate": "Grading Rate",
        "answerrate": "Answer Rate",
        "averagescore": "Average Score",
        "poll": "Poll",
        "grading": "Grading",
        "webgradetips": "Tips: try a more convenient way to grade Open questions on Rain Classroom Web at {url}.",
        "accuracy": "Accuracy",
        "objectivequestion": "Objective Question",
        "answerrate": "Answer Rate",
        "teacherdatacheck": "Check",
        "studentfeedback": "Student Feedback",
        "anonymous": "Anonymous",
        "unread": "Unread",
        "nostudentfeedback": "No feedback.",
        "detaileddata": "Detailed Data",
        "webdownloadexcel": "Please download all Excel data on Rain Classroom Web at {url}.",
        "teachingdesign": "Instructional Design&Memo",
        "teachingdesigntip": "You can take notes here. (Private)",
        "editpublishtitle": "Edit Title",
        "deletepublish": "Delete Publish",
        "loadmore": "Load more",
        "mailreceivedata": "Please type your email address to receive detailed data:",
        "enterfrequentmail": "Please write down your frequently used email address:",
        "mailformaterror": "Email Format Error",
        "datasentok": "Sent Successfully",
        "yktwebtips": "Tips: on Rain Classroom Web at {url}",
        "enternewtitle": "Please enter the new title.",
        "deletepulishcfm": "Are you sure to delete?",
        "deletepublishfailed": "Delete Failed",
        "previewdetails": "Preview Details",
        "finisheddetails": "Finished Details",
        "gradingdetails": "Grading Details",
        "name": "Name",
        "score": "Score",
        "submission": "Submission",
        "gradingtime": "Grading Time",
        "noonefinished": "No student has finished",
        "testfinisheddetails": "Test Completion",
        "finisheddetails": "Completion",
        "checktestpaper": "Check Test Paper",
        "graded": "Graded",
        "finishedtest": "Finished Test",
        "checktestpaper": "Check Test Paper",
        "totalstudentone": "Total Students",
        "viewdetails": "View Details",
        "scoredistribution": "Score Distribution",
        "allvote": "Test Type: Polls",
        "ungradedsubjectiveproexist": "You still have ungraded Open questions.",
        "clickbarcharttograde.": "Click bar chart of Open questions to grade.",
        "noonefinishedtest": "No student has finished.",
        "qbxsyjj": "All students have submitted.",
        "answerdetails": "Answer Details",
        "grading": "Grading",
        "deleteexcelnow": "You can download detailed Excel data directly.",
        "deletepulishcfm": "Are you sure to delete?",
        "deletepublishfailed": "Delete Failed",
        "standardopt": "The correct answer is:",
        "noanswerforpoll": "There is no correct answer for poll",
        "option": "Option",
        "name": "Name",
        "loadingdata": "Loading...",
        "answered": "Answered",
        "notansweredone": "Not answered",
        "lessonexciese": "Questions",
        "lessonquiz": "Quizzes",
        "score": "Score",
        "gradeone": "Grading",
        "stick": "",
        "loadmore": "Load more",
        "okone": "OK",
        "thisquestion": "thisquestion",
        "point": "Point",
        "cancel": "Cancel",
        "positivescore": "Score must be positive.",
        "exceedmaximumscore": "Exceed maximum score, please try again.",
        "keepadecimal": "One decimal at most , please try again.",
        "numberonlywarning": "Numbers only, please try again.",
        "unclearstudents": "\"Unclear\" Students",
        "unclearstudents1": "\"Unclear\" Students<span class=\"font18\">{count}</span>student(s)",
        "noquestiontoanswer": "The teacher didn't send any questions in this class.",
        "nounclearslides": "No Unclear Slides",
        "nocommentslides": "Nothing Here~",
        "commentcount": "Comment",
        "quantityone": "Bonus Quantity：",
        "noquestiontoanswer": "The teacher didn't send any questions in this class.",
        "standardopt": "The correct answer is :",
        "noanswerforpoll": "No correct answer for the poll.",
        "gradingtime": "Grading Time",
        "timelimitedtest": "This is a time-limited test.",
        "min": "mins",
        "deadline": "Deadline",
        "testdeadline": "Test Deadline",
        "timelimitedtest": "This is a time-limited test.",
        "checkhw": "Check",
        "finishedhw": "Submitted Assignments",
        "hwfinisheddetail": "Assignment Completion",
        "finishedhwstudent": "students have finished the assignments",
        "gradedhwnumber": "assignments have been graded.",
        "scorereport": "Score Report",
        "questionlocate": "Question",
        "accuracyone": "Accuracy",
        "editpublishtitle": "Edit Title",
        "deletepublish": "Delete Publish",
        "deletepublishone": "Are you sure to delete?",
        "deletepublishfailed": "Delete Failed",
        "mailreceivedata": "Please type your email address to receive detailed data:",
        "enterfrequentmail": "Please write down your frequently used email address.",
        "datasentok": "Sent Successfully",
        "submission": "Submission",
        "searchname": "Search Name",
        "checktestpaper": "Check Test Paper",
        "randomrollcallinthisclass": "Random Roll Call",
        "signedinstudent": "Attended",
        "totalsignedstudent": "Total: X students",
        "signin": "Sign In",
        "dot": "",
        "person": "",
        "ci": "",
        "nistudenttocall": "No student in the class",
        "correctopt": "Correct Answer",
        "wrongopt": "Wrong Answer",
        "anonymouspollnodetail": "This is an anonymous poll.",
        "totalamountofbonus": "Total Amount",
        "rmb": "CNY",
        "bonusnotopened": "Not Opened",
        "notansweredtwo": "Not Answered",
        "votemost": "Most Voted:",
        "standardopt": "The correct answer is:",
        "voteoption": "Vote Option",
        "nostudentanswered": " No answers",
        "studentfinishedpreview": "Finished",
        "previewdetail": "Details",
        "finishpreview": "Finished",
        "privateteachingnote": "You can take notes here. (Private)",
        "mailreceivedata": "Please type your email address to receive detailed data:",
        "activestudent": "Active Students",
        "enterclass": "In Class",
        "activestudentnumber": "Active",
        "totalclassstudent": "Total",
        "studentdata": "Student Data",
        "notfinalrank": "The ranking might change due to ungraded Open questions.",
        "totalrank": "Ranking",
        "notfinalrank": "The ranking might change due to ungraded Open questions.",
        "brilliantstudent ": "Brilliant Students",
        "timespenttwo": "Time Spent",
        "warningstudent": "Underperforming Students",
        "trackstudentprogress": "Track student progress by sending questions in class",
        "studentanswerdata": "Answer Details",
        "barcharttograde": "Click bar chart to grade",
        "totalquestions": "Total Questions",
        "teachingunclearpage": "\"Unclear\" Pages",
        "teachingtotalslidesno": "Total Slides",
        "teachingsubjectiveproungraded": "You have ungraded Open questions.",
        "classdanmu": "Danmu",
        "classpost": "Posts",
        "randomrollcall": "Random Roll Call",
        "senddetaileddata": "Send detailed data",
        "teachingcontents": "Teaching Content",
        "totalpagenumber": "Total Pages:",
        "teachingdesign": "Instructional Design&Memo",
        "privateteachingnote": "You can take notes here. (Private)",
        "coteacherlimit": "The co-teacher is not allowed to delete teaching activities.",
        "deletepublishone": "Are you sure to delete?",
        "coteacherlimit": "The co-teacher is not allowed to delete teaching activities.",
        "deletefailedretry": "Delete Failed. Please try again later.",
        "one": "",
        "countone": "{count}个",
        "tipsdownloadwebdata": "Tips: please download all Excel data on Rain Classroom Web at {url}.",
        "notsignedin": "Absenced",
        "total": "Total",
        "totalone": "Total",
        "pro": "Questions",
        "teachingcheck": "Check",
        "slidesdetail": "Slides Details",
        "inclassquiz": "Quizzes",
        "quizedit": "Edit",
        "comment": "Comment",
        "good": "Good!",
        "comeon": "Come on!",
        "uniqueidea": "Extraordinary!",
        "excellent": "Excellent!",
        "enterscoretip": "Please enter score.",
        "invaildinput": "Invalid input, please try again.",
        "positivescore": "Score must be positive.",
        "exceedmaximumscore": "Exceed maximum score, please try again.",
        "keepadecimal": "One decimal at most , please try again.",
        "sendprotips": "How to send questions?",
        "slidesdetails": "Slides Details",
        "inclassquiz": "Quizzes",
        "emptyhelp": "Click here to get help",
        "emptysildes": "No sildes here",
        "emptysildesupload": "Try to upload Slides on PowerPoint(Rain Classroom)",
        "emptyquiz": "No tests here",
        "emptyquizupload": "Try to upload Tests on PowerPoint(Rain Classroom)",
        "studentsVisible": "Visible to Students",
        "visibleAll": "All Slides",
        "visibleStu": "In-class slides",
        "visibleAllnot": "All invisible",
        "visiblepart": "Partly visible",
        "pointnotviewpage": "Click to select the invisible pages",
        "nocheck": "Invisible",
        "editviewpage": "Edit",
        "stucheckauth": "学生查看权限",
        "ppt_limit_ques1": "Please confirm that all slides are visible to students.",
        "ppt_limit_ques2": "Please confirm that only the slides interpreted in class are visible to students.",
        "ppt_limit_ques3": "Please confirm that all slides are not visible to students.",
        "nextDefault": "Remember this option",
        "setSuc": "OK",
        "paperLookLimit": "View Limit",
        "lookLimit": "View Limit",
        "alwaysLook": "Always visible",
        "afterHand": "Invisible when submitted",
        "afterHandTips": "After the deadline, students are unable to view the test even If they didn’t submit",
        "afterCannot": "Students are unable to view the test after setting. Only test result shown. ",
        "changeForNot": "After changing complete deadline, it will be only applied to the students who have not completed it",
        "changeForNot1": "The new deadline is only valid for unsubmitted students. ",
        "addBlack": "Add to Blacklist（After that, students are unable add class.）",
        "blackList": "Blacklist",
        "checkblackList": "Check Blacklist",
        "haimeiyouStu": "No Students in the class",
        "remove": "Remove",
        "confirmRemove": "Are you sure to remove the student from blacklist?",
        "removeTips": "Students are able to add to class via QR code or class code when removed",
        "quanweida": "No one answered",
        "quanyida": "All answered ",

        // 打分
        "newtotalscore": "The total score is {total} point(s)",
        "hupingtotalscore": "The total score is {total} point(s), {groupReviewProportion}% from peer grading and {teacherProportion}% from teacher grading",
        "finalscore": "Final score",
        "teachergrading": "Teacher grading",
        "peergrading": "Peer grading",
        "totalmembers": "{num} people",
        "noComment": "No comment",
        "newpoint": "",
        "fulltext": "Full text",
        "fold": "fold",
        // 填空题
        "correctcount": "correct",
        "sendtokfail": " class(es) have not received",
        "sentokthree": "Send failed:",
        "touchtoresend": "(Resend by clicking the right button)",
        "touchtoresend2": "(Unlimited classes can resend by clicking the right button.)",

        // 手动批改填空题
        "showquestion": "Show Question",
        "tocorrect": "Are you sure to correct?",
        "addcorrectanswer": "Add correct answer(regrade all the answers)",
        "regradeanswers": "Click to regrade the answers",
        "submitone2": "Submit",
        "notallow": "Not allow to add the correct answer if the answers are out of order",

        "nonickname": "nickname not set",

        "tips2": "Tips:Extension of the deadline only works for the unsubmitted students.",
        "watchedreplay": "Replayed",
        "replayed": "Replayed",
        "signinempty": "Nothing Here",
        "unsignempty": "Nothing Here",
        "watchempty": "Nothing Here",

        "xingmingzimu": "By initials",
        "xuehaoxiaodaoda": "Ascending",
        "xuehaodadaoxiao": "Descending",
        "meiyoushuju": "No data",
        "clickloadmore": "Load more",


        "live": "Live",
        "livemin": "min",
        "totalduration": "Total:",
        "liveduration": "Duration:",
        "online": "Online Person:",
        "livetip": "The total time refers to the sum of the online duration of all the users who joined the interactive live (including the teacher), and Rain Classroom uses this total time to calculate the traffic consumed.",
        "hideproblemtips": "No exercise data will be displayed for classes with more than 3000 students.",
        "txmeetingsuccess": "Tentcent meeting replay has been saved to Rain Classroom",
        "txmeetingfail": "Tentcent meeting replay not saved to Rain Classroom",
        "txmeetingcannotdel": "The replay not saved to Rain Classroom,deleted in Tencent meeting will not be recovered, please delete it carefully.",
        "txmeetingcandel": "The replay has been saved to Rain Classroom.Deleting it in Tencent meeting will not affect the normal viewing of the replay.",
    },

    //群发公告
    pubnotice: {
        'successTop':'Successfully',
        'successCancle':'Successfully',
        'failTop':'Unsuccessful',
        'failCancle':'Unsuccessful',

        "topNotice":'Top',
        'success':'Successfully',
        'fail': 'Unsuccessful',
        'cancleNotice':'Cancel',
        "cancelTop":'Cancel Top',
        "showall": "Show All",
        "totalattachment": "Total {length} attachments",
        "downloadfromyktweb": "You can download it from {url}",
        "delannoucement": "Delete",
        "teachernameann": "Instructor {teacherName}'s announcement",
        "ykt": "Rain Classroom",
        "noundocfm": "You can't undo this action.",
        "confirmdel": " Are you sure to delete this announcement?",
        "fileunablepreview": "The file cannot be previewed.",
        "readynum": "{ready_num} read",

        'commenttitle':'Are you sure to delete the comment？',
        "replytitle": 'Are you sure to delete the comment',
        "delreplyreplyoptions": 'It cannot be recovered after deletion',
        "delcommentoptions": 'It cannot be recovered after deletion.Replies under this comment will also be deleted',

        "announcementlimit": "Tips:Two for each class per day.",
        "announcementquota": "",
        "msunit": "left",
        "titlerequired": "Title (Required)",
        "selectTime": "Select delivery time",
        "sendannouncementtips":"You can send texts, images, links to students (please add a space or press Enter to confirm before and after entering the link address)",
        "cancel": "Cancel",
        "send": "Send",
        "sendto": "Send to：",
        "title": "Title",
        "backtoedit": "Back to edit",
        "cfmtosend": "Confirm",
        "sendok": "Sent Successfully",
        "notempty":'The announcement’s content cannot be empty.',
        "gotit": "Got it",
        "sendoktoclass": "Sent Successfully：",
        "publishannouncement": "Publish Annoucement",
        "delpiccfm": "Are you sure to delete?",
        "exiteditcfm": " Are you sure to exit?",
        "timerequred": "The posting time must be filled in and cannot be earlier than the current time",
        "unabletosendannouncement": "You can't send any announcements.",
        "titlenullwarning": " The title must not be null",
        "announcementnullwarning": "The announcement must not be null.",
        "golimit": "Announcement limit exceeded. Failed to send.",


        "allclass": "{course_name}'s class",
        "entertitle": "Please enter a title",
        "entercontent": "Please enter content",
        "selectclassplease": "Please select a class",
        "faileduploadnotsend": "The attachment will not be sent once failed to upload.",
        "selectclasstopublish": "Please select a class",
        "selectedclass": "Selected Class",
        "cancel": "Cancel",
        "announcementok": "OK",
        "maxfilesize": "Max: 10 attachment, 30M per file, 100M in total.",
        "attachnumberselected": "{ilen} attachments selected",
        "fileselectleft": "You can choose {ilen} more.",
        "addattachedment": "Add Attachments",
        "del": "Delete",
        "reupload": "Re-upload",
        "uploadfailed": "Upload Failed",
        "delundocfm": "Are you sure to delete? You can't undo this action.",
        "maxuploadfilenumber": "Maximum {max_fileCount} files",
        "totaluploadmaxsize": "The total size should be no more than {totalFileSize}M",
        "waiting": "Waiting ...",
        "uploadcompleted": "Completed",
        "filesizeexceedlimit": "File size exceeds limit",
        "sendtofollowingclass": "Sent to the following class:",
        "edit": "Edit",
        "cannotoplink": "Link cannot be opened",
        "miniprogramtip":"The external links cannot be opened in Mini Program. Please open them via Rain Classroom Official Account. ",
        "miniprogramhelp":"HELP",
        "fileformatlimit": "Unqualified Format",

        //web端群发公告添加
        "maxcharnum_tip":"You have entered {ilen} characters.  Exceed maximum limit（1000 characters),  please reduce content",
        "clickShowClasses_1": "Click ",
        "clickShowClasses_2": " to show all classes of the course",
        "noRight": "You don't have permission to publish any announcement to this classroom",
        "webuptips": "Tips: You can upload attachments to publish annoucement on web.",
        "sendclass": "Send Classes",
        "addclass": "Add Classes",
        "noticetitle": "Announcement Title",
        "titleplaceholder": "Please input the title of the announcement",
        "linktips": "Tip: If you enter the link address manually, please add a space or carriage return before and after the link address to confirm.",
        "previewsend": "Preview and Send",
        "createnew": "Create a Announcement",
        "archiveclass": "You have to remove the classrooms from the Archive"
    },

    //课件、试卷文件夹管理
    my_folder_manage:{
        'notempty': 'Name cannot be empty',
        "myupload":"Uploaded",
        "myreceived":"Received",
        "chosequiz":"Choose Tests",
        "singlechose":"one only",
        "choseslide":"Choose Slides",
        "noslide":"No slides here",
        "tryuploadslide":"Try to upload Slides on PowerPoint (Rain Classroom) ",
        "nouploadquiz":"No Tests here",
        "tryuploadquiz":"Try to upload Tests on PowerPoint (Rain Classroom) ",
        "seehelp":"Click here to get help",
        "createOK":"Successful",
        "updateOK":"Successful",


        "noslidereceived":"No slides here",
        "inyourclass":"All slides you received will be displayed here.",
        "inyourclass_quiz":"All quizzes you received will be displayed here.",
        "mobileslide":"",
        "and":"",
        "lessonslide":"",
        "comehere":"",
        "noquiz":"No tests here",
        "mobilequiz":"",
        "lessonquiz":"",

        "newfolder":"New Folder",
        "movefolder":"Move to Folder",
        "deletequiz":"Delete Tests",
        "deleteslide":"Delete Slides",
        "management":"Manage",
        "foldername":"Enter here",
        "complete":"OK",
        "inputlenlimited":"12 characters limit. Please try again.",

        "folderempty":"Empty here",
        "folderempty1":"You can move slides to folder for better management.",
        "folderempty1_quiz":"You can move tests to folder for better management.",
        "renamefloder":"Rename",
        "moveoutquiz":"Move to...",
        "moveoutslide":"Move to...",
        "deletefolder":"Delete",
        "deletefoldertip":"All slides will be deleted with the folder",
        "tips":"Tips",
        "deleteok":"OK",

        "chosefolder":"Choose the target folder",
        "mycollections":"My Slides",
        "rootdir":"Root Directory",
        "move":"Move",
        "choseonefolder":"Choose a  Folder",
        "moveok":"OK",

        "chosealready":"Chosen: ",
        "nextstep":"Next",
        "deleteslidetip":" Are you sure to delete these slides?",
        "deletequiztip":"Are you sure to delete these tests?",
    },

    //课件、试卷文件夹管理
    my_folder_manage:{
        'notempty': 'Name cannot be empty',
        "myupload":"Uploaded",
        "myreceived":"Received",
        "chosequiz":"Choose Tests",
        "singlechose":"one only",
        "choseslide":"Choose Slides",
        "noslide":"No slides here",
        "tryuploadslide":"Try to upload Slides on PowerPoint (Rain Classroom) ",
        "noquiz":"No Tests here",
        "nouploadquiz":"No Tests here",
        "tryuploadquiz":"Try to upload Tests on PowerPoint (Rain Classroom) ",
        "seehelp":"Click here to get help",
        "createOK":"Successful",
        "updateOK":"Successful",

        "noslidereceived":"No slides here",
        "inyourclass":"All slides you received will be displayed here.",
        "inyourclass_quiz":"All quizzes you received will be displayed here.",
        "mobileslide":"",
        "and":"",
        "lessonslide":"",
        "comehere":"",
        "noquiz":"No tests here",
        "mobilequiz":"",
        "lessonquiz":"",

        "newfolder":"New Folder",
        "newfolderlimit": "New Folder (within 64)",
        "movefolder":"Move to Folder",
        "deletequiz":"Delete Tests",
        "deleteslide":"Delete Slides",
        "management":"Manage",
        "foldername":"Please enter...",
        "complete":"OK",
        "inputlenlimited":"12 characters limit. Please try again.",

        "folderempty":"Empty here",
        "folderempty1":"You can move slides to folder for better management.",
        "folderempty1_quiz":"You can move tests to folder for better management.",
        "renamefloder":"Rename",
        "renamefloderlimit":"Rename (within 64)",
        "renamefile": "Rename (within 64)",
        "filename": "Please enter...",
        "moveoutquiz":"Move to...",
        "moveoutslide":"Move to...",
        "deletefolder":"Delete",
        "deletefoldertip":"All slides will be deleted with the folder",
        "tips":"Tips",
        "deleteok":"OK",

        "chosefolder":"Choose the target folder",
        "mycollections":"My Slides",
        "rootdir":"Root Directory",
        "move":"Move",
        "choseonefolder":"Choose a  Folder",
        "moveok":"OK",

        "chosealready":"Chosen: ",
        "nextstep":"Next",
        "deleteslidetip":" Are you sure to delete these slides?",
        "deletequiztip":"Are you sure to delete these tests?",
        "deleteslidesingletip": "Are you sure to delete？",
        "deletequizsingletip": "Are you sure to delete？",
        "swipLeftDelRename": "Swipe Left to delete or rename",
        "swipLeftDelRename1": "Swipe Left to delete or rename",
        "rename": "Rename",
        "toolong": "Text too long",
        "delete": "delete",
        "random": "Random",
        "updateApp": "更新APP版本后可参加在线监考",
        "dati": "Dict",
        "zuhe": "Group",
        "paperPublishTips": "Cannot publish: incorrect group of papers",
    },

    // 图片资源
    img: {
        empty_colletion: "https://qn-sfe.yuketang.cn/o_1c2tpurrvhn8aum1j5epq9ktn9.png",
        empty_class: "https://qn-sfe.yuketang.cn/o_1c2vgkbhp12o41nbl9hl1g11a6va.png",
        empty_student_blank: "https://qn-sfe.yuketang.cn/o_1c2vgkbhp146f1obn1apcgm5ug4b.png",
        empty_score_detail: "https://qn-sfe.yuketang.cn/o_1c2vi9a4910iq1npkuau13bc1gr512.png",
        empty_task: "https://qn-sfe.yuketang.cn/o_1c2vipfihnoi77ed8218i61fng9.png",
        empty_msg: "https://qn-sfe.yuketang.cn/o_1c2vipr7e1re31ors1f54150a5hae.png",
        notice_delete: "https://qn-sfe.yuketang.cn/o_1c2virdfs11ahnoa1j8j7cpm21j.png",
        notice_forbidden: "https://qn-sfe.yuketang.cn/o_1c2vkeka313b1oln1b34189i5si1c.png",
        notice_alllook: "https://qn-sfe.yuketang.cn/o_1c2vv8gp110g81saqghr1jgd1hbhl.png",
        notice_allnotsee: "https://qn-sfe.yuketang.cn/o_1c2vv8gp1iav1icb1qv191a1bi8k.png",
        tougao_student: "https://qn-sfe.yuketang.cn/o_1c2vtgl92fc11pofoot1ggv1clc9.png",
        tougao_teacher: "https://qn-sfe.yuketang.cn/o_1c2vtgl92fc11pofoot1ggv1clc9.png",
        empty_teach_log: "https://qn-sfe.yuketang.cn/o_1c2vu3suq1n301udr167h1io61r78o.png",
        empty_store: "https://qn-sfe.yuketang.cn/o_1c2vuha452lvh8656b18e71ppv9.png",
        empty_bill: "https://qn-sfe.yuketang.cn/o_1c2vvp4al1ttqbgv1dq48j01ug5t.png",
        empty_paper: "https://qn-sfe.yuketang.cn/o_1c2vi9a4910iq1npkuau13bc1gr512.png",
        learning_complete: "https://qn-sfe.yuketang.cn/o_1c300slik11qr5e5i8af7qssdk.png",
        learning_uncomplete: "https://qn-sfe.yuketang.cn/o_1c300slik1oocfgs61b70culfl.png",
        teacher_allsign: "https://qn-sfe.yuketang.cn/o_1c5khl7ikf0t1g6mm00v9s1s6q9.png",
        teacher_allnotsign: "https://qn-sfe.yuketang.cn/o_1c2vv8gp1iav1icb1qv191a1bi8k.png",
        gkk_log_empty: "https://qn-sfe.yuketang.cn/o_1c304p03sju232qdi722r1hf817.png",
        fans_empty:"https://qn-sfe.yuketang.cn/o_1c5ktqueq1me6144g111fpfc1mq19.png",
        batch_log: "https://qn-sfe.yuketang.cn/o_1emtrsdqra3n11ta13c51cm107vb.5x.png",
        noupload_img: "https://qn-sfe.yuketang.cn/o_1fu69dk83psqvmp1bqmucp1uigc.png",
        noupload_img_shu: "https://qn-sfe.yuketang.cn/o_1fu69dk83e1i68mch71h5pmuge.png",
    },

    // 错误提示信息
    error: {
        "contentdel": "This content has been deleted by the teacher.",
        "checkfromactivity": "Please check slides from Activities.",
        "noauthslides": "You are not allowed to check it.",
        "classdel": "The class has been deleted.",
        "nocontent": "Page Not Found ~",
        "cannotlearnclassend": "The course is currently over, the learning unit is not supported learning.",
    },

    // 习题集
    problemset: {
        "myquestions": "My Questions",
        "wrongquestionno": "Wrong",
        "totalquestionno": "Total",
        "errorrate": "Error Rate",
        "questionupdatetime": "Update",
        "total": "Total",
        "wrongquestion": "Wrong",
        "markquestions": "Starred",
        // "tests": "Test",
        // "slides": "Slides",
        "viewhistory": "Start From Last Time",
        "noquestion": "Nothing Here",
        "nowrongquestion": "No wrong questions yet",
        "nomarkquestion": "No starred questions yet.",
        "questionno": "Question{index}",
        "mark": "Star",
        "viewdetails": "Check",
        "takenotes": "Take Note",
        "redo": "Re-do",
        "goanswering": "Answer",
        "answerdetails": "Answer Details",
        "correctanswer": "Correct Answer",
        "answerforfirsttime": "Your First Answer",
        "correct": "Correct",
        "wrong": "Wrong",
        "answernotreleased": "Not released it.",
        "notanswered": "Not Answered",
        "score": "Score",
        "point": "Points: {count}",
        "specificstudentscore": "{count}",
        "comment": "Comment",
        "answerkey": "Answer Key",
        "myanswer": "My Answer",
        "redotips": "Re-do is only for self-test, results will not be submitted to the teacher.",
        "gotit": "Got it",
        "comfirm": "OK",
        "answercorrect": "Correct",
        "answerwrong": "Wrong",
        "note": "Note",
        "takenotestips": "You can take notes here(private)",
        "save": "Save",
        "edit": "Edit",
        "checknotes": "Check Note",
        "nosetscore": "Not graded yet.",
        "datacollecting": "Data collecting…",
        "noqustions": "No questions yet.",
        "groupanswered": "Group answer:",
    },

     // 讨论区
    discusstion: {
        'Me':'me',
        'releaseSuccess':'Successfully',
        'releaseFaild':'Failed',
        "releaseFaildclass": "Failed classes:",
        "releasefinish": "Release completed.",
        "sendsuc": "{succount}/{total} classes have received.",
        "comment": "Comments",
        "digg": "Like",
        "commentplaceholder": "Enter here...",
        "send": "Send",
        "reply": "Reply",
        "edit": "Edit",
        "delete": "Delete",
        "from": "From {name}",
        "delconfirm": "Are you sure to delete?",
        "expand": "Show All",
        'unexpand':'close',
        "replyallcount": "View More",
        "loadmore": "Load More",
        "commentsuccess": "Successful",
        "replysuccess": "Successful",
        "replycomment": "Reply...",
        "backtopic": "back to topic",
        "youropinion": "Add a comment",
        "viewimage": "Image",
        "imagelimit": " No more than {count} pictures",

        //列表页
        "loaddata": "Loading...",
        "publishtime": "Published Time",
        "empty_tip": "No comment here",
        "empty_tip2": "",
        "discussion": "Discussion",
        "new_idea": "Enter here...",
        "publishbtn": "Post",
        "new_discussion": "Discussion",
        "pic_max": "9 pictures at most",
        "waitloading": "Uploading...",
        "deletedtip": "All content related will be deleted",
        "onlypic": "[pic]",
        'loading': 'loading...',
        end:'end'
    },

    plupload:{
        'Select_files' : 'Select files',
        'Add_files_to_queue' : 'Add files to the upload queue and click the start button.',
        'Filename' : 'Filename',
        'Status' : 'Status',
        'Size' : 'Size',
        'Add_Files' : 'Add Files',
        'Stop_Upload' : 'Stop Upload',
        'Start_Upload' : 'Start Upload',
        'Add_files' : 'Add files',
        'Add_files2' : 'Add files.',
        'Stop_current_upload' : 'Stop current upload',
        'Start_uploading_queue' : 'Start uploading queue',
        'Stop_upload' : 'Stop upload',
        'Start_upload' : 'Start upload',
        'Uploaded_files': 'Uploaded %d/%d files',
        'N_A' : 'N/A',
        'Drag_files_here' : 'Drag files here.',
        'File_extension_error': 'File extension error',
        'File_size_error': 'File size error.',
        'File_count_error': 'File count error.',
        'Init_error': 'Init error.',
        'HTTP_Error': 'HTTP Error.',
        'Security_error': 'Security error.',
        'Generic_error': 'Generic error.',
        'IO_error': 'IO error.',
        'File_s': 'File: %s',
        'Close': 'Close',
        'files_queued': '%d files queued',
        'Using_runtime: ': 'Using runtime: ',
        'File_size_max_file_size': 'File: %f, size: %s, max file size: %m',
        'Upload_element_accepts': 'Upload element accepts only %d file(s) at a time. Extra files were stripped.',
        'Upload_URL_might': 'Upload URL might be wrong or doesn\'t exist',
        'Error_File_too_large': 'Error: File too large: ',
        'Error_Invalid_file_extension': 'Error: Invalid file extension: '
    },

    //新教学日志学习日志
    newlogs: {
        "transcript": "Transcript",
        "student": "Members",
        "discussion": "Discussion",
        "task": "Tasks",
        "setting": "Settings",
        "xiti": "Questions",
        "classmate": "Classmates",
        "teachinglog": "Activities",
        "learinglog": "Activities",
        "publish": "Publish",
        "all": "Total",
        "lesson": "Lecture",
        "slide": "Slides",
        "quiz": "Quizzes",
        "notice": "Announcement",
        "loading": "Loading......",
        "clicktopublish_t": "Click \"+\" to publish teaching activities to students",
        "clicktopublish_s": "No teaching activity yet",
        "clicktopublish_exp": "No Experiment Here",
        "publishslide": "Slides",
        "publishquiz": "Quizzes",
        "publishnotice": "Announcement",
        "term": "Semester: 2017-2018 Spring Term",
        "onlessontip": "You have {length} lessons in class",
        "appointment": "Scheduled Delivery",
        "top":'TOP',
        "appointmenttip": "You have {length} Scheduled Deliveries",
        'topAnnouncement': 'You have {length} top announcement(s)',
        'unreadByTopNotice': '{length} unread',
        "unread": "unread",
        "courseedittitle": "Edit Title",
        "delete": "Delete",
        "week": "",
        "month": "",
        "day": "",
        "onlesson": "In class",
        "publishaftermin": "Send in {minute} mins",
        "publishafterhour": "Send in {hour} hours",
        "publishafterday": "Send in {days} days",
        "publishafterhour": "Send Failed",
        "experiment": "Experiment",
        "entertitle": "Enter a new title~",
        "conotedit": "The co-instructor is not allowed to edit title",
        "conotdel": "The co-instructor is not allowed to delete teaching activities",
        "coursedelpubish": "Once you delete it, all teaching data of this activity will be deleted",
        "confirmdelete": "Are you sure to delete the teaching activity？",
        "exp": "Experiment",
        "syllabus": "Syllabus",
        "group": "Group",
        "livereplay": "Replay of Live",
        "exam": "Exam",
        "video": "Video",
        "audio": "Audio",
        "discuss": "Discussion",
        "article": "Reading",
        "homework": "Assignment",
        "online": "Study Online",
        "live": "Live",
        "notallowededit": "Not allowed to edit title.",
        "studydeadline": "Please complete your studies by {deadline}",
        "integrityagreement": 'Integrity Agreement',
        "learnagreenment": 'Integrity Agreement',
        "agreen": 'Agree',
        'cancel': 'Cancel',
        "logs_start_time": "Start Time: ",
        "logs_end_time": "No End Time",
        "logs_to": "to",
    },
    //协同教师管理
    manage_coteacher: {
        "sendletter_tip": "You can chat with others by clicking members’ photos",
        "promotebtn": "Add",
        "invitebtn": "Add",
        "managemenu": "Manage",
        "addstudent": "Add Student",
        "studentlimit": "(Class size can not be more than {count}.)",
        "delstudent": "Delete Student",
        "addcoteacher": "Add Co-instructor",
        "delcoteacher": "Remove Co-instructor",
        "delcoteacher1": "Remove Co-instructor",
        "delcoteachertip": "Once removed, the co-instructor will be in class as a student.",
        "coteachertit": "Tips",
        "coteacherintor1": "1. Co-instuctor can start class, publish teaching activities, and manage students.",
        "coteacherintor2": "2. Co-instuctor can enter class, but cannot answer questions and quizzes.",
        "coteacherintor3": "3. Co-instuctor cannot add new co-instructors or create new class, but can delete teaching activities only.",
        "nocoteacher": "No co-instructor in this class",
        "noStudent": "No student in this class",
        "cancel_check": "Clear",
        "confirmdelete": "Are you sure to delete the teaching activity？",
        "exp": "Experiment"
    },
    setcourse: {
        "liveStatus0":'Permission denied',
        "liveStatus1":'In review',
        "liveStatus2":'Application failed',
        "liveStatus3":'Permission',
        "livePermission":'Live permission',
        "fullname": "Full Name",
        "shortname": "Short Name",
        "optional": "Optional",
        "shortname_tip": "Please fill in the short name of the course.",
        "coursetype": "Course Type",
        "required": "Required",
        "k12": "K-12",
        "university": "University",
        "other": "Others",
        "next": "Next",
        "shortname_placeholder": "Enter a short name (6 characters limit)",
        "full_tip": "Full Name",
        "edit": "Edit",
        "classname": "Class Name",
        "semester": "Semester",
        "join_limit": "Join Limit",
        "limit_tip1": "Once enabled,student can't join class by entering class code or scaning QR codes.",
        "limit_tip2": "You can change this limit by setting in Teaching History of this class.",
        "complete": "OK",
        "editable": "editable",
        "pro_coursetip": "Rain Classroom Pro does not support modification of course name or type.",

        "noset": "Not set",
        "k12": "K-12",
        "university": "University",
        "others": "Others",
        "semester1": "Semester 1",
        "semester2": "Semester 2",
        "spring": "Spring",
        "summer": "Summer",
        "fall": "Fall",
        "winter": "Winter",
        "pre": "Previous",
        "courseInfo": "Set the class type before the course semester.",
        "fallterm": "Fall Semester {year}",
        "springterm": "Spring Semester {year}",
        "summerterm": "Summer Semester {year}",
        "clickhere": "Click here",
        "viptips": " to apply for the Rain Class member.You can live broadcast in all class if you be a member.",
        "studentlimits": "The limit is on.",
        "limitstoast": "You can not close the limit.",
        "classfeatures": "Features available to Class",
        "unavailablefeatures": "Unavailable features will no longer be shown.",
        "notopenfforum": "You cannot open the discussion as school required",
        "notopenall": "You cannot open the function because the number of people has reached the limit",
        "allnotjoin": "Can't join",
        "nojoinafterend": "Can't join after lesson",
        "outsidetheschoolcannotjoin": "Outsiders can‘t join",
        "unselectedstudentsjoinautomatic": "Students can choose courses",
        "studentsnotsupportedtoselect": "Students can't choose courses",

        "studyunitlimit": "Learning Unit Viewing Limits",
        "canstudyafterclass": "Can viewing after course",
        "cannotstudyafterclass": "Can’t viewing after course",
    },
    letter: {
        "role": "Role",
        "school": "School",
        "studentid": "Student ID",
        "organ": "Organ.",
        "email": "Email",
        "chat": "Chat",
        "saysomething": "Say something here~",
        "bindingtip": "You can only send message to binding school users."
    },
    // 互评
    grading: {
        "scoreofpeergrading": "Score of Peer Grading",
        "scoreofteachergrading": "Score of Teacher Grading",
        "pointsofgrading": "Grading Criteria",
        "textareaplaceholder": "Please enter the key or points for students' reference.",
        "hupingguize": "Rules of Peer Grading",
        "rule1": "<i>＊</i>Groups can take part in peer grading only after answer submission. Each group will receive <span class='f15'>One</span> answer from other groups.",
        "rule2": "The peer grading is anonymous.",
        "rule3": "The teacher can change the proportion of peer grading to teacher grading or edit the final score at any time.",
        "faqihuping": "Launch",
        "cancel": "Cancel",
        "save": "Save",
        "launchedgrading" : "A peer grading is launched.",
        "pointsgrading" : "Points for Grading",
        "grade" : "Grade",
        "answer" : "Answer",
        "gradingscore" : "Peer grading score: {score} point(s)",
        "gradingtotalscore" : "Enter the score (total score is {score} point(s))",
        "notice" : "Notice",
        "noticecontent" : "This question is graded by groups. Each student has only one chance to grade the question, and only the last submission in each group will be accepted as the final score.",
        "close" : "Close",
        "gradedalready" : "Graded Already",
        "gradedoverwrite" : "Your submission will overwrite the present grading.",
        "pleasescore" : "Please grading now",
        "updateOK":"Successful",
    },
    // 开放平台
    platform: {
        "moretoweb": "更多批改请使用雨课堂网页版",
        "mustpoint": "Required Points: {count}",
    },
    // 手机号绑定
    bindmobile: {
        "bindPhone": "Bind Phone",
        "lawtips": "Real-name authentication is required by law. Please bind your phone number to ensure the availability and security of your account.",
        "extractminiprogram": "Extract the mini program code to bind the phone",
        "closewindow": "Close this window after binding complete"
    },
    //身份认证
    identifyAudit:{
        'infoMsg':'Please complete the identity verification truthfully,otherwise it will be rejected.',
        'realName':'Real Name',
        'placeholder1':'Enter your real name',
        'placeholder2':'Bind phone',
        'placeholder3':'Unverified',
        "hasBind":"Completed",
        'phoneNumber':'Phone Number',
        'idCard':'Upload your ID card ',
        'workCard':'Upload your Employee’s card ',
        'idCardDetail':'Please read the tips and upload photos as required.',
        'emailDetail':'If you are a college teacher, it is recommended to fill in the school mailbox and verify the email address.~',
        'email':'School-mailbox(optional)',
        'btn':'Submit',
        'clickExplain1':"Take photo of personal details",
        'clickExplain2':"Take photo of front cover",
        'clickExplain3':"Take photo of Employee’s card",
        'identifyAudit':'Identity Verification ',
        'warmInfo':"Tips",
        'warmInfoDetail':"Please refer to the following figure to upload the Employee’s card in the correct way. The picture is no more than 10M, so be sure to collect the information of the Employee’s card only itself.",
        'uploadImage':"upload photos",
        "requestError": "Request failed,please refresh and try again.",
        'backhomepage': 'Back to home page'
    },
    mystore: {
        'tsinghuabindtitle': 'Welcome to 「Lotus Pond」!',
        'tsinghuacontent': 'Please verify Tsinghua University identity first.',
        'bind': 'Bind'
    },
   //直播审核
    liveAudit:{
        "liveApply":'Live application',
        'rowLabel1':'Name',
        'rowLabel2':'Course',
        'rowLabel3':'Class',
        'applyReason':'Reason for application:',
        'btn1':'Submit',
        'btn2':'Back',
        'fail':'Failed',
        'success':'Success',
        'info':'The review will be completed in 7 weekdays.',
        'tip2':'Your application has been submitted successfully and the review will be completed in 7 weekdays.You will rereceive the notice in Rain Classroom if it finished.Thanks for your using！',
        'placeholder1':'Please describe the reasons for the application in detail,including but not limited to live users,live content and the live broadcast times.',
        'tip':'Special note: Users must use the live broadcast service to abide by relevant national laws and policies, and assume all responsibilities arising from users illegal use or violation of the original intention of the broadcast (including but not limited to speech, transmission, etc.) The user is fully responsible.',
        'viptips': 'Tips:The personal information you provide will be strictly protected and will only be used for identity verification. We will not use the information for other purposes without your permission.',
    },

    // 给学生增加备注需求增加
    behavior: {
        "bonuspoint": "Bonus",
        "addpoints": "+{count}",
        "howtoaddpoints": "How to add Bonus Point?",
        "backtoclass": "Back to Class",
        "remarks": "Remarks",
        "entername": "Enter student's name",
        "points": "",
        "changethestate1": "Present",
        "changethestate2": "Absent",
        "nobonuspoint": "No Bonus Point",
        "tag": "Tag",
        "save": "Save",
        "edittag": "Edit Tag",
        "addtag": "Add tag",
        "afterclasstips": "You can find this in your Class Report",
        "entercontent": "Please enter the content",
        "noquizzes": "No quizzes in this class",
        "noeligiblestudents": "No Eligible Students",
        "performance": "Performance",
        "present": "present",
        "absent": "absent",
        "yiqiandao": "Signed In",
        "weiqiandao": "Not Signed in",
        "changetosignin": "Present",
        "changetonotsignin": "Absent",
        "bonus": "Bonus",
        "pleaseenterinteger": "Integer required",
        "systemtag": "System Labels are not editable",
        "tagexists": "The same tag already exists",
        "edit": "Edit",
        "other": "Other",
        "qr": "Scan QR code",
        "classcode": "'Class Code",
        "share": "Share",
        "manualmark": "Manual mark",
        "classtip": "Class Tip",
    },

    // 会员审核
    vipAudit: {
        "applyReason": "Reason for application:",
        "placeholder1": "Please describe the reasons for the application in detail,including but not limited to the function you want to use,the usage and the purpose…",
        "vipApply": "Application",
        "experienceinadvance": "Experience in advance",
        "boardonPC": "Board on PC",
        "insertaudio": "Insert local audio and video into the slides",
        "livebroadcastinclass": "Live broadcast in class",
        "morefeaturescomingsoon": "More features coming soon!",
        "distinguishedmembers": "Hello! VIP",
        "periodofvalidity": "period of validity",
        "advance1": "",
        "advance2": "",
        "advance3": "",
        "btn1":"Submit",
        "btn2":"Back",
        "fail":"Failed",
        "success":"Success",
        "info":"We will review your application information as soon as possible",
        "tip2":"Your application has been submitted successfully. We will review your application information as soon as possible. You will rereceive the notice in Rain Classroom when it finished.Thanks for your using！",
        'interactiveinclass': 'Interactive in class',
        'invigilatingexam': 'Invigilating Exam',
        'downloadpapers': 'Download Papers',
        "advance4": "",
        "advance5": "",
        "advance6": "",
        "chujihuiyuan": "Hello! Primary Members",
        "zhongjihuiyuan": "Hello! Intermediate Members",
        "gaojihuiyuan": "Hello! Advanced Members",
        "chaojihuiyuan": "Hello! SVIP",
        "cloudsave": "Cloud Storage",
        "advance7": ""
    },

    bindschool: {
        "addschool": "Add school",
        "shenfenbang": "Identity binding",
        "bindtipsshow": `<div class="pt10 landscape_p20 text-left">The school work ID / student ID and course data can be synchronized after binding.</div><div class="mt5 landscape_p20 text-left"> If you need to open it, please contact 400-689-1199 by your school administration.</div>`,
        "binded": "Bound.",
        "weiguixiao": "It is not connected with the educational administration system of your school and identity binding is not supported yet.",
        "search": "Search",
        "xuehao": "Student ID",
        "gonghao": "Work ID",
        "yuanxi": "Faculty",
        "sureunbind": "Are you sure to unbind {name}",
        "unbindinacc": "Unbinding account",
        "canceunbinding": "Cancel unbinding",
        "jiechuchenggong": "Unbinding account successfully",
        "qxiaoyouhui": "Tsinghua Alumni Association",
        "pleasepc": "Please visit on computer.",
        "qufendaxiao": "Case sensitive",
        "beishistep": "Step 1:<br/>please verify your identity in the \"Enterprise  Account of Beijing Normal University\".<br/> If you have verified, please skip this step.",
        "beishiqr": `Keep pressing the QR code to enter the "Enterprise  Account of Beijing Normal University".`,
        "bindstep": "Step 2:<br/>Please click to bind your identity of Rain Classroom.",
        "bindid": "Identity bind",
        "weibindtips": "You haven’t bound the school account, please bind first.",
        "phonenum": "Phone number",
        "zmindenti": "Work ID",
        "identi": "Identity",
        "plid": "Please select identity.",
        "account": "Account",
        "password": "Password",
        "verificode": "Verification Code",
        "tipscode": "Tips:Please enter the verification code shown on the right.",
        "plenterphone": "Please enter phone number",
        "tips": "Tips:",
        "xiaoneitips": "Only school account login is supported. For self-registered account, please go to account login for verification.",
        "confirmbind": "Confirm binding",
        "cancelbind": "Cancel binding",
        "verisuc": "Verification successful",
        "numhouback": "Return automatically in {num} second(s)",
        "cmycourse": "Check my courses",
        "yiaccount": "Abnormal account ",
        "renzheng1": "1.You have passed the identity authentication, but your account information is not found in the “{name}-Rain Classroom” system. The system automatically creates<span class='color63'> a school  account for you as a student</span>.",
        "renzheng2": "2.The school account created by the system will take the account you used for authentication as your student ID , the name is your WeChat nickname, and the year of enrollment is the top four student ID by default.",
        "renzheng3": "3.This kind of account cannot be associated with school data. If you join the school course now, you will attend the class as a <span class='color63'>guest student, and the learning data will be recorded.",
        "xuyaoacteacher": "If necessary, please contact the school teacher of educational administration to update the information.",
        "gotit": "Got it.",
        "bindfaied": "Failed to bind",
        "rebind": "Rebind",
        "getcode": "Get verification code",
        "num6last": "The last 6 phone numbers",
        "guoguan": "School of International Relations",
        "inputpass1": "Please enter the password used to log in  the school educational administration system.",
        "numberwrong": "Wrong phone number",
        "resend": "Resend",
        "idnoempty": "Student ID cannot be empty.",
        "passnoempty": "Password cannot be empty.",
        "selcode": "Please enter verification code.",
        "verifying": "Verifying",
        "wrongcode": "Wrong verification code ",
        "reginfo": "Registration information",
        "gotobind": "Go to bind",
        "plphonenum": "Please enter phone number",
        "backreg": "返回注册页面",
        "yibangdingzhanghao": `You have been bound to the <span class="color3 font-weight-600">{name}</span> of Technology account,<br/> If you need to modify, please unbind the account first.`,
        "gaixuexiaobushuzai": `This school is deployed on the "{enName}" server, please go to the {name} official account to complete the identity verification.`,
        "changanshibie": "Long press to identify, the QR code is valid until {expire}",
        "qiehuanservertips": "Are you sure to switch server?",
        "gaixuexiaobushuzaichongxindenglu": `This school is deployed on the "{enName}" server, and you need to switch to the "{name}" server to log in again.` ,
        "qiehuan": "Switch server",
        "emailverify": "Email",
        "informationnotfill": "The information is not completely filled in",
        "emailformatwrong": "Incorrect email format",
    },

    // 新版首页同步过来的组件
    mobile: {
        // account-logout.vue
        "viewdetail": "view details",
        "logouttips": `ID【{userid}】The application for canceling the account is being confirmed. The expected effective time is: {date}`,
        "accountcancellationinprogress": "Account cancellation in progress",
        "userID": "User ID: ",
        "expectedeffectivetime": "The expected effective time: ",
        "unrecoverableafterlogout": "Unrecoverable after completing the logout process",
        "cancellogoutsuccess": "Cancelling logout succeeded!",
        "cancellogout": "cancel logout",
    }
}



if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['exports'], function() {
        return pages;
    });
} else if (typeof exports === 'object' && typeof module === 'object') {
    module.exports = exports = pages; // CommonJS
}

export default pages;



// WEBPACK FOOTER //
// ./src/language/en.js